<template lang="pug">
    .shopping-cart(:class="{ 'empty-list': ! items || ! items.length }")
        .body(ref="body" v-dragscroll)
            .nothing-scanned(v-if="! items || ! items.length")
                i.el-icon-fa-barcode.fas
                h4 {{ $t('Nothing Scanned') }}
                //- p {{ $t('Where the heck are the customers?') }}
            .items(v-else)
                table
                    thead
                        tr
                            th.col-left(colspan="2") {{ $t('Article') }}
                            th.dimmed.col-right {{ $t('Price') }}
                            th.col-center {{ $t('Quantity') }}
                            th.col-right {{ $t('Total') }}
                    transition-group(name="slide-decent-vertical" tag="tbody")
                        template(v-for="item in items.slice().reverse()")
                            tr(:key="`${item.id}:1`")
                                td.divider(colspan="5")
                                    hr
                            tr(:key="`${item.id}:2`")
                                td.min(rowspan="2")
                                    item-media-preview(:item="item")
                                td.info.col-left(valign="top")
                                    .name(v-line-clamp="1")
                                        b {{ item.name }}
                                    small {{ item.product_nr }}
                                    span &nbsp;/&nbsp;
                                    small {{ item.sku }}
                                td.min.dimmed.col-right
                                    el-button.customize-price.flex(
                                        type="primary"
                                        plain
                                        icon="el-icon-fa-pencil fas"
                                        @click="askForDiscount(item)"
                                    )
                                        .missing-price(v-if="item.price == undefined")
                                            nobr {{ $t('missing') }}
                                        .sale-price(v-else-if="item.sale_price && item.sale_price < item.price")
                                            .nobr
                                                s.strike-through {{ item.price | moneyFormat(currencyCode) }}
                                                //- span.percentage {{ (item.price - item.sale_price) / item.price * 100 | round(2) }}%
                                            nobr.red {{ item.sale_price | moneyFormat(currencyCode) }}
                                        .sale-price(v-else-if="item.sale_price && item.sale_price > item.price")
                                            nobr {{ item.sale_price | moneyFormat(currencyCode) }}
                                        nobr(v-else) {{ item.price | moneyFormat(currencyCode) }}
                                td.min.col-center
                                    el-input-number.qty(
                                        v-if="!item.manage_stock || !getRelevantArticleStocks(item.article).length"
                                        :value="getTotalItemQty(item)"
                                        size="medium"
                                        :min="1"
                                        :step-strictly="true"
                                        @change="qty => updateItemQty(item, qty)"
                                    )
                                    .flex(v-else)
                                        el-input.qty(
                                            :value="getTotalItemQty(item)"
                                            size="medium"
                                            suffix-icon="el-icon-fa-pencil fas"
                                            @click.native="showStocksEdit(item)"
                                        )
                                        //- el-button.pencil.ml-1(
                                        //-     type="info" size="mini"
                                        //-     icon="el-icon-fa-pencil fas"
                                        //-     :disabled="! item.article.stocks.length"
                                        //-     @click="showStocksEdit(item)"
                                        //- )
                                td.min.col-right
                                    .missing-price(v-if="item.price == undefined")
                                        nobr.dimmed {{ $t('missing') }}
                                    .sale-price(v-else-if="item.sale_price && item.sale_price < item.price")
                                        .nobr
                                            //- s.strike-through {{ item.price * item.qty | moneyFormat(currencyCode) }}
                                            small.percentage {{ (item.price - item.sale_price) / item.price * 100 | round(2) }}%
                                        b.nobr.red {{ item.sale_price * getTotalItemQty(item) | moneyFormat(currencyCode) }}
                                    .sale-price(v-else-if="item.sale_price && item.sale_price > item.price")
                                        b.nobr {{ item.sale_price * getTotalItemQty(item) | moneyFormat(currencyCode) }}
                                    b.nobr(v-else) {{ item.price * getTotalItemQty(item) | moneyFormat(currencyCode) }}
                            tr(:key="`${item.id}:3`")
                                td(colspan="4" valign="bottom")
                                    .bottom-row
                                        .properties
                                            property-value(
                                                v-for="property in item.properties.filter(el => el.selectable)"
                                                :key="property.id"
                                                :property="property"
                                            )
                                        .actions.flex-row
                                            el-tag.inactive-tag(
                                                v-if="isInactive(item)"
                                                size="mini"
                                                type="danger"
                                            ) {{ $t('inactive') }}
                                            //- el-button.put-aside(
                                            //-     v-if="item.manage_stock"
                                            //-     plain
                                            //-     type="primary"
                                            //-     size="mini"
                                            //-     icon="el-icon-fa-archive fas"
                                            //-     @click="putArticleAside(item)"
                                            //-     disabled
                                            //- ) {{ $t('Put Aside') }}
                                            .unsavable(v-if="item.manage_stock && getAvailableQty(item) <= 0")
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 96C0 60.7 28.7 32 64 32l242.7 0c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3l0 19.5c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32z"/><path class="fa-primary" d="M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"/></svg>
                                            el-button.stocks(
                                                v-if="item.manage_stock"
                                                plain
                                                type="primary"
                                                size="mini"
                                                icon="el-icon-fa-dolly fas"
                                                :disabled="! item.article.stocks.length"
                                                @click="showStocks(item)"
                                            ) {{ $t('Stocks') }}
                                            //- el-button.discount(
                                            //-     type="warning"
                                            //-     size="mini"
                                            //-     icon="el-icon-fa-percent fas"
                                            //-     @click="askForDiscount(item)"
                                            //- ) {{ $t('Discount') }}
                                            el-button.delete-item(
                                                circle
                                                plain
                                                type="danger"
                                                size="mini"
                                                icon="el-icon-fa-trash-alt far"
                                                @click="deleteItem(item)"
                                            )
                    tr
                        td.divider(colspan="5")
                            hr

        transition(name="slide-decent-vertical")
            .customer-search-popover.gray-box(
                v-if="customerSearchPopover.visibility === true"
                :class="{ 'has-coupons': coupons.length || applicableCustomerCoupons.length }"
            )
                .form(
                    v-if="customerSearchPopover.newMember.visibility"
                    v-dragscroll
                )
                    el-form.new-customer-form(
                        :model="customerSearchPopover.newMember.form"
                        :rules="customerSearchPopover.newMember.rules"
                        label-position="top"
                        ref="customerForm"
                        @submit.prevent.native="createCustomer"
                    )
                        .flex-row
                            el-form-item(:label="$t('Gender')" prop="gender")
                                el-select.is-small(
                                    placeholder=""
                                    clearable
                                    v-model="customerSearchPopover.newMember.form.gender"
                                )
                                    el-option(:label="$t('Mr.')" value="M")
                                    el-option(:label="$t('Mrs.')" value="F")
                                    el-option(:label="$t('Undefined')" value="X")
                            el-form-item.grow(:label="$t('First name')" prop="first_name")
                                el-input(
                                    v-model="customerSearchPopover.newMember.form.first_name"
                                    maxlength="255"
                                    show-word-limit
                                    @focus="$set(customerSearchPopover, 'focusedField', 'first_name')"
                                )
                            el-form-item.grow(:label="$t('Last name')" prop="last_name")
                                el-input(
                                    v-model="customerSearchPopover.newMember.form.last_name"
                                    maxlength="255"
                                    show-word-limit
                                    @focus="$set(customerSearchPopover, 'focusedField', 'last_name')"
                                )
                        .flex-row
                            el-form-item.grow(:label="$t('Email')" prop="email")
                                el-input(
                                    v-model="customerSearchPopover.newMember.form.email"
                                    maxlength="255"
                                    show-word-limit
                                    @focus="$set(customerSearchPopover, 'focusedField', 'email')"
                                )
                            el-form-item.grow(:label="$t('Phone')" prop="phone")
                                el-input(
                                    v-model="customerSearchPopover.newMember.form.phone"
                                    maxlength="255"
                                    show-word-limit
                                    @focus="$set(customerSearchPopover, 'focusedField', 'phone')"
                                )

                        h3 {{ $t('Address') }}
                        .address
                            el-form-item(:label="$t('Street')" prop="address.street")
                                el-input(
                                    v-model="customerSearchPopover.newMember.form.address.street"
                                    maxlength="255"
                                    show-word-limit
                                    @focus="$set(customerSearchPopover, 'focusedField', 'address.street')"
                                )
                            .flex-row
                                el-form-item(:label="$t('Zipcode')" prop="address.zipcode")
                                    el-input(
                                        v-model="customerSearchPopover.newMember.form.address.zipcode"
                                        maxlength="255"
                                        show-word-limit
                                        @focus="$set(customerSearchPopover, 'focusedField', 'address.zipcode')"
                                    )
                                el-form-item.grow(:label="$t('City')" prop="address.city")
                                    el-input(
                                        v-model="customerSearchPopover.newMember.form.address.city"
                                        maxlength="255"
                                        show-word-limit
                                        @focus="$set(customerSearchPopover, 'focusedField', 'address.city')"
                                    )
                            el-form-item(:label="$t('Country')" prop="address.country")
                                el-select.is-full-width(
                                    placeholder=""
                                    filterable
                                    v-model="customerSearchPopover.newMember.form.address.country"
                                    autocomplete="no-fill"
                                )
                                    el-option(
                                        v-for="(label, value) in countries"
                                        :key="value"
                                        :label="label"
                                        :value="value"
                                    )
                .list(
                    v-else
                    ref="customerSearchPopoverBody"
                    @scroll="handleCustomerSearchScroll"
                    :class="{ 'is-empty': !customerSearchPopover.pagination.items.length }"
                    v-dragscroll
                )
                    ul.customers.no-style-list(v-if="! customerSearchPopover.loading")
                        li.customer(v-for="member in customerSearchPopover.pagination.items")
                            .infos
                                .row
                                    .name {{ member.name }}
                                    .nr.grow \#{{ member.customer.nr }}
                                    .phone {{ member.phone }}
                                .row
                                    .address.grow(v-if="member.address" v-line-clamp="1") {{ member.address.oneLiner }}
                                    .email {{ member.email }}
                            .actions
                                el-button(
                                    type="success"
                                    icon="el-icon-fa-check fas"
                                    @click.prevent="selectCustomer(member)"
                                ) {{ $t('Select') }}
                    .popover-spinner-container(v-if="customerSearchPopover.loading || customerSearchPopover.pagination.loading")
                        .spinner-background
                            .spinner
                .input
                    el-form.customer-search-form(
                        :model="customerSearchPopover.form"
                        label-position="top"
                        ref="customerSearch"
                        @submit.prevent.native="searchCustomers"
                    )
                        .flex-row.bottom-row(v-if="!customerSearchPopover.newMember.visibility")
                            el-button.add-customer(
                                type="success"
                                icon="el-icon-fa-plus fas"
                                @click.prevent="showNewMemberForm"
                            ) {{ $t('Add customer') }}
                            el-input.grow(
                                v-model="customerSearchPopover.form.input"
                                ref="customer-search-input"
                                @keydown.native.esc="closeCustomerSearchPopover"
                            )
                                template(slot="prefix")
                                    i.fas.el-icon-fa-magnifying-glass
                        .flex-row.bottom-row(v-else)
                            el-button.add-customer(
                                type="info"
                                @click.prevent="hideNewMemberForm"
                            ) {{ $t('Cancel') }}
                            .grow
                            el-button.add-customer(
                                type="primary"
                                icon="el-icon-fa-check fas"
                                :loading="customerSearchPopover.newMember.saving"
                                @click.prevent="createCustomer"
                            ) {{ $t('Save') }}
                        Keyboard(v-model="customerKeyboardInput" @key-press="handleCustomerSearchKeyboardKeyPress")

        transition(name="slide-decent-vertical")
            .coupon-search-popover.gray-box(v-if="couponSearchPopover.visibility === true")
                .input
                    .spinner(v-if="couponSearchPopover.loading")
                    el-form.coupon-search-form(
                        :model="couponSearchPopover.form"
                        label-position="top"
                        ref="couponSearch"
                        @submit.prevent.native="applyCoupon"
                    )
                        el-input.search-input(
                            v-model="couponSearchPopover.form.input"
                            ref="coupon-search-input"
                            @keydown.native.esc="closeCouponSearchPopover"
                        )
                        Keyboard(v-model="couponSearchPopover.form.input" @key-press="handleCouponSearchKeyboardKeyPress")

        portal(to="app")
            transition(name="fade")
                .backdrop(
                    v-if="customerSearchPopover.visibility === true"
                    @click="closeCustomerSearchPopover"
                )
                .backdrop(
                    v-else-if="couponSearchPopover.visibility === true"
                    @click="closeCouponSearchPopover"
                )

        .foot(:class="{ 'has-coupons': coupons.length || applicableCustomerCoupons.length }")
            .coupons.gray-box(
                v-if="coupons.length || applicableCustomerCoupons.length"
                :class="{ active: couponSearchPopover.active }"
                @click.prevent.stop="closeCouponSearchPopover"
            )
                label {{ $t('Coupons') }}
                CouponList(@close-popover="closeCouponSearchPopover")
                .flex-row
                    .actions
                        //- el-button(
                        //-     v-if="!coupons.length"
                        //-     plain
                        //-     size="small"
                        //-     type="primary"
                        //-     icon="el-icon-fa-search fas"
                        //-     @click="toggleCouponSearchPopover"
                        //- ) {{ $t('Apply coupon') }}
                        //- el-button(
                        //-     v-else
                        //-     plain
                        //-     size="small"
                        //-     type="primary"
                        //-     icon="el-icon-fa-plus fas"
                        //-     @click="toggleCouponSearchPopover"
                        //- ) {{ $t('Apply another coupon') }}
                        el-button(
                            plain
                            size="small"
                            type="primary"
                            icon="el-icon-fa-search fas"
                            @click.prevent.stop="toggleCouponSearchPopover"
                        ) {{ $t('Apply coupon') }}
                    .discount-summary(v-if="discount")
                        b.value {{ discount | moneyFormat(currencyCode) }}
            button.coupons.gray-box(v-else @click="toggleCouponSearchPopover" :class="{ active: couponSearchPopover.active }")
                label {{ $t('Coupons') }}
                //- .value.gray
                //-     i.el-icon-fa-receipt.fas &nbsp;
                //-     span {{ $t('Apply coupon') }}
                .value.gray.grow
                    //- i.el-icon-fa-plus.fas
                    svg.icon(
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                    )
                        path(
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
                        )
            .session
                button.customer.gray-box(@click="toggleCustomerSearchPopover" :class="{ active: customerSearchPopover.active }")
                    label {{ $t('Customer') }}&nbsp;
                        template(v-if="purchaser.customer && purchaser.customer.nr") \#{{ purchaser.customer.nr }}
                    .value(v-line-clamp="1") {{ purchaser.name === 'Guest' ? $t(purchaser.name) : purchaser.name }}
                    button.unset-customer(
                        v-if="purchaser.customer"
                        @click.prevent.stop="unsetCustomer"
                    )
                        i.el-icon-fa-times.fas
                el-button.action(
                    v-if="purchaser.customer && purchaser.customer.nr"
                    plain
                    type="primary"
                    icon="el-icon-fa-history fas"
                    @click="showCustomerPurchaseHistory"
                )
                el-button.action(
                    plain
                    :loading="puttingCartAside"
                    :type="!purchaser.customer || !items.length || containsUnsavableItems ? 'info' : 'primary'"
                    icon="el-icon-fa-save fas"
                    :disabled="!purchaser.customer || !items.length || containsUnsavableItems"
                    @click="putCartAside"
                )
                el-button.action(
                    v-if="dirty && items.length"
                    plain
                    type="danger"
                    icon="el-icon-fa-trash-alt far"
                    @click="showClearCartDialog = true"
                )

            .summary
                .qty-sum.gray-box
                    label {{ $t('Quantity Sum') }}
                    .value {{ qtySum }}
                .grand-total.gray-box
                    label {{ $t('Total') }}
                    b.value(v-if="discount && discount > 0")
                        span.line-through {{ total+discount | moneyFormat(currencyCode) }}
                        span.red {{ total | moneyFormat(currencyCode) }}
                    b(v-else).value {{ total | moneyFormat(currencyCode) }}
                el-button.action(
                    type="primary"
                    icon="el-icon-fa-percent fas"
                    :disabled="total == 0"
                    @click="askForTotalDiscount"
                )
                el-button.action(
                    type="success"
                    icon="el-icon-fa-cash-register fas"
                    @click="checkout"
                )

        el-dialog.delete-menu-item-dialog(
            :title="$t('Clear Shopping Cart')"
            :visible.sync="showClearCartDialog"
            :close-on-click-modal="false"
            :append-to-body="true"
            top="10vh"
            width="460px"
        )
            .body
                p {{ $t('Do you really want to clear the shopping cart?') }}
            template(slot="footer")
                .modal-footer
                    .left
                        el-button(
                            size="mini"
                            icon="el-icon-fa-times fas"
                            @click="showClearCartDialog = false"
                        ) {{ $t('Cancel') }}
                    .right
                        el-button(
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            @click="clearCart"
                        ) {{ $t('Clear Cart') }}

        el-dialog.stocks-modal(
            :title="$t('Stocks')"
            :visible.sync="stocksModal.visibility"
            top="10vh"
            width="560px"
            @close="$emit('focus-search')"
            @closed="resetStockModal"
        )
            .body(v-if="stocksModal.item")
                .info
                    .row
                        nobr.nr {{ stocksModal.item.product_nr }}
                        nobr.name {{ stocksModal.item.name }}
                        nobr.price(v-if="stocksModal.item.price !== undefined") {{ stocksModal.item.price | moneyFormat(currencyCode) }}
                    .row.properties
                        property-value(
                            v-for="property in stocksModal.item.properties.filter(el => el.selectable)"
                            :key="property.id"
                            :property="property"
                        )
                    .row
                        nobr.sku
                            label {{ $t('SKU') }}:
                            span.value {{ stocksModal.item.sku }}
                        transition(name="slide-decent-left")
                            nobr.re-ordered(v-if="stocksModal.item.pending_delivery_qty > 0")
                                label {{ $t('Re-Ordered') }}:
                                span.value {{ stocksModal.item.pending_delivery_qty }}
                        nobr.qty
                            label {{ $t('Quantity') }}:
                            span.value {{ stocksModal.item.qty || 0 }}
                table.default-table(v-if="stocksModal.item.article.stocks.length")
                    thead
                        tr
                            th.min.spinner-container
                                .spinner(v-if="stocksModal.loading")
                            th.col-left.name
                                nobr {{ $t('Stock') }}
                            th.col-left.sellable
                                //- nobr {{ $t('Sellable From/To') }}
                            th.col-center.qty
                                nobr {{ $t('Available') }}
                            th.min.actions
                    tbody
                        tr.spacer
                            td(colspan="5")
                        tr.stock(v-for="stock in stocksModal.item.article.stocks")
                            td.min.icon
                                span.icon.disabled(v-if="stock && stock.status !== 'enabled'")
                                    el-tooltip(effect="dark" :content="$t('Disabled in the stock settings')" placement="top")
                                        i.el-icon-warning
                                span.icon.sold-out(v-else-if="stock.pivot.qty <= 0")
                                    el-tooltip(effect="dark" :content="$t('Sold out')" placement="top")
                                        i.el-icon-warning-outline
                                span.icon.enabled(v-else)
                                    i.el-icon-success
                            td.col-left.name
                                nobr {{ stock.name }}
                            td.col-left.sellable
                                nobr.danger
                                    .from(v-if="stock.pivot.sellable_from && isFuture(stock.pivot.sellable_from)")
                                        | {{ $t('From') }}: {{ stock.pivot.sellable_from | timestamp2date($t('yyyy-MM-dd')) }}
                                    .to(v-if="stock.pivot.sellable_to && isPast(stock.pivot.sellable_to)")
                                        | {{ $t('To') }}: {{ stock.pivot.sellable_to | timestamp2date($t('yyyy-MM-dd')) }}
                            td.min.col-center.qty
                                nobr {{ stock.pivot.qty }}
                            td.min.col-right.actions
                                nobr(v-loading="stock.loading")
                                    el-button(
                                        v-if="stock && stock.pivot.qty > 0 && ! (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                        type="text"
                                        :disabled="stock.loading"
                                        @click.stop="requestArticle(stock)"
                                    ) {{ $t('request 1x') }}
                                    //- el-button(
                                    //-     v-else-if="stock && (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                    //-     type="text"
                                    //-     :disabled="stock.loading"
                                    //-     @click.stop="takeBackArticle(stock)"
                                    //- ) {{ $t('take back 1x') }}
                        tr.spacer
                            td(colspan="5")

        el-dialog.stocks-modal(
            :title="$t('Edit quantities per stock')"
            :visible.sync="stocksModalEdit.visibility"
            top="10vh"
            width="560px"
            @close="$emit('focus-search')"
            @closed="resetStockModalEdit"
        )
            .body(v-if="stocksModalEdit.item")
                .info
                    .row
                        nobr.nr {{ stocksModalEdit.item.product_nr }}
                        nobr.name {{ stocksModalEdit.item.name }}
                        //- nobr.price(v-if="stocksModalEdit.item.price !== undefined") {{ stocksModalEdit.item.price | moneyFormat(currencyCode) }}
                    .row.properties
                        property-value(
                            v-for="property in stocksModalEdit.item.properties.filter(el => el.selectable)"
                            :key="property.id"
                            :property="property"
                        )
                    .row
                        nobr.sku
                            label {{ $t('SKU') }}:
                            span.value {{ stocksModalEdit.item.sku }}
                table.default-table(v-if="stocksModalEdit.item.article.stocks.length")
                    thead
                        tr
                            th.min.spinner-container
                                .spinner(v-if="stocksModalEdit.loading")
                            th.col-left.name
                                nobr {{ $t('Stock') }}
                            th.col-left.sellable
                                //- nobr {{ $t('Sellable From/To') }}
                            th.col-center.qty
                                nobr {{ $t('Available') }}
                            th.min.actions
                                nobr {{ $t('Selected') }}
                    tbody
                        tr.spacer
                            td(colspan="5")
                        //- tr.stock(v-for="stock in stocksModalEdit.item.article.stocks")
                        tr.stock(v-for="(stock, s) in stocksModalEdit.availableStocks")
                            td.min.icon
                                span.icon.disabled(v-if="stock && stock.status !== 'enabled'")
                                    el-tooltip(effect="dark" :content="$t('Disabled in the stock settings')" placement="top")
                                        i.el-icon-warning
                                span.icon.sold-out(v-else-if="stock.pivot.qty <= 0")
                                    el-tooltip(effect="dark" :content="$t('Sold out')" placement="top")
                                        i.el-icon-warning-outline
                                span.icon.enabled(v-else)
                                    i.el-icon-success
                            td.col-left.name
                                nobr {{ stock.name }}
                            td.col-left.sellable
                                nobr.danger
                                    .from(v-if="stock.pivot.sellable_from") {{ $t('From') }}: {{ stock.pivot.sellable_from | timestamp2date($t('yyyy-MM-dd')) }}
                                    .to(v-if="stock.pivot.sellable_to") {{ $t('To') }}: {{ stock.pivot.sellable_to | timestamp2date($t('yyyy-MM-dd')) }}
                            td.min.col-center.qty
                                nobr {{ stock.pivot.qty }}
                            td.min.col-right.actions
                                nobr(v-loading="stock.loading")
                                    el-input-number.qty(
                                        :value="stock.qty"
                                        size="mini"
                                        :step-strictly="true"
                                        :min="0"
                                        @change="qty => updateStocksModalEditQty(s, qty)"
                                    )
                        tr.spacer
                            td(colspan="5")
                transition(name="slide-decent-vertical" mode="out-in")
                    .alert.warning(v-if="stocksModalEdit.availableStocks.reduce((pv, cv) => pv + cv.qty, 0) == 0")
                        | {{ $t('Please select at least one article in a stock.') }}
                .mt-6.modal-footer(slot="footer")
                    .left
                        el-button(
                            size="small"
                            icon="el-icon-fa-times fas"
                            @click="closeQtyEditModal"
                        ) {{ $t('Dismiss') }}
                    .right
                        el-button(
                            :disabled="stocksModalEdit.availableStocks.reduce((pv, cv) => pv + cv.qty, 0) == 0"
                            type="success"
                            @click="saveQtyEditModal"
                        ) {{ $t('Ok') }}

        el-drawer.checkout-drawer(
            :title="$t('Finish purchase')"
            :visible.sync="checkoutDrawer.visibility"
            :modal="true"
            size="50%"
            @close="$emit('focus-search')"
            @closed="resetCheckoutDrawer"
        )
            .drawer-body(v-dragscroll)
                template(v-if="paymentMethods.length")
                    //- el-divider(content-position="left") {{ $t('Customer') }}
                    .customer.gray-box
                        label {{ $t('Customer') }}
                        .value {{ purchaser.name === 'Guest' ? $t(purchaser.name) : purchaser.name }}
                    //- el-divider(content-position="left") {{ $t('Payment method') }}
                    .summary
                        .qty-sum.gray-box
                            label {{ $t('Articles') }}
                            .value {{ qtySum }}
                        //- template(v-if="true")
                            .sub-total.gray-box
                                label {{ $t('Subtotal') }}
                                .value {{ total | moneyFormat(currencyCode) }}
                            .sub-total.gray-box
                                label {{ $t('Coupons') }}
                                .value {{ total | moneyFormat(currencyCode) }}
                        .grand-total.gray-box
                            label {{ $t('Total') }}
                            b.value {{ total | moneyFormat(currencyCode) }}
                        .estimated-remaining.gray-box(v-if="returnRemainingCouponAmountAsCash")
                            label {{ $t('Remaining value') }}
                            b.value {{ estimatedRemainingCouponValue | moneyFormat(currencyCode) }}
                    .buttons
                        el-button(
                            v-for="paymentMethod in paymentMethods" :key="paymentMethod.id"
                            :plain="! checkoutDrawer.form.paymentMethod || checkoutDrawer.form.paymentMethod.id !== paymentMethod.id"
                            type="primary"
                            :icon="getPaymentMethodIcon(paymentMethod)"
                            @click="updateCheckoutPaymentMethod(paymentMethod)"
                        ) {{ paymentMethod.name }}
                        el-button(
                            v-if="splitPaymentFeatureEnabled && paymentMethods.length >= 2"
                            :plain="checkoutDrawer.split === false"
                            type="primary"
                            icon="fas el-icon-fa-cut"
                            @click="selectSplitPayment"
                        ) {{ $t('Split payment') }}
                        .spacer.grow
                        el-button.payout-remaining-value(
                            v-if="hasEligibleRemainingAmountCoupon"
                            :plain="!returnRemainingCouponAmountAsCash"
                            type="primary"
                            icon="el-icon-fa-hand-holding-usd fas"
                            @click="returnRemainingCouponAmountAsCash = !returnRemainingCouponAmountAsCash"
                        ) {{ $t('Pay out remaining value') }}
                    transition(name="slide-decent-vertical" mode="out-in")
                        .split(v-if="checkoutDrawer.split" key="split")
                            template(v-for="(splitPayment, i) in checkoutDrawer.form.split")
                                .payment(:key="splitPayment.paymentMethod.id")
                                    //- label {{ splitPayment.paymentMethod.name }}
                                    .contains-numpad
                                        .input-payed-amount(v-if="checkoutDrawer.split === splitPayment.paymentMethod.service")
                                            num-pad(
                                                :value="splitPayment.amount"
                                                :decimal-separator="checkoutDrawer.money.decimal"
                                                :thousands-separator="checkoutDrawer.money.thousands"
                                                :prevent-default="true"
                                                @input="value => updateSplitPaymentMethodAmount(i, value)"
                                                @update="value => splitPayment.placeholder = value"
                                                type="float"
                                            )
                                        .money(:class="{ inactive: checkoutDrawer.split !== splitPayment.paymentMethod.service }")
                                            .payed
                                                .gray-box.input
                                                    label {{ splitPayment.paymentMethod.name }}
                                                    //- label {{ $t('Payed') }}
                                                    .value.invisible {{ splitPayment.amount | moneyFormat(currencyCode) }}
                                                    money.value(
                                                        :value="splitPayment.amount"
                                                        v-bind="checkoutDrawer.money"
                                                        @input="value => updateSplitPaymentMethodAmount(i, value)"
                                                        @focus.native="checkoutDrawer.split = splitPayment.paymentMethod.service"
                                                    )
                                                    .value.input {{ splitPayment.placeholder }}
                                            transition(name="slide-decent-vertical")
                                                template(v-if="checkoutDrawer.split === splitPayment.paymentMethod.service")
                                                    .remainings(v-if="(remainings = (total - checkoutDrawer.form.payed)) && remainings > 0")
                                                        .gray-box
                                                            label {{ $t('Remaining amount') }}
                                                            .value {{ remainings | moneyFormat(currencyCode) }}
                                                        .actions
                                                            el-button(
                                                                v-if="i < paymentMethods.length - 1"
                                                                type="info"
                                                                icon="el-icon-fa-arrow-down fas"
                                                                @click="transferSplitPaymentRemainings(i+1, total - splitPayment.amount)"
                                                            ) {{ $t('transfer') }}
                                                            el-button(
                                                                v-else
                                                                type="info"
                                                                icon="el-icon-fa-arrow-up fas"
                                                                @click="transferSplitPaymentRemainings(i-1, total - splitPayment.amount)"
                                                            ) {{ $t('transfer') }}
                                                    .change(v-else-if="(change = (total - checkoutDrawer.form.payed) * -1) && change > 0")
                                                        .gray-box
                                                            label {{ $t('Change') }}
                                                            .value {{ change | moneyFormat(currencyCode) }}
                        .cash.contains-numpad(v-else-if="checkoutDrawer.form.paymentMethod && checkoutDrawer.form.paymentMethod.digital === false" key="cash")
                            .input-payed-amount
                                num-pad(
                                    ref="numpad"
                                    v-model="checkoutDrawer.form.payed"
                                    :decimal-separator="checkoutDrawer.money.decimal"
                                    :thousands-separator="checkoutDrawer.money.thousands"
                                    @update="content => checkoutDrawer.numpad = content"
                                    type="float"
                                )
                                //- .gray-box.input
                                //-     label &nbsp;
                                //-     .value.invisible {{ checkoutDrawer.form.payed | moneyFormat(currencyCode) }}
                                //-     input.value(v-model="checkoutDrawer.form.payed" v-bind="checkoutDrawer.money")
                            .money
                                .payed
                                    .gray-box.input
                                        label {{ $t('Payed') }}
                                        .value.invisible {{ checkoutDrawer.form.payed | moneyFormat(currencyCode) }}
                                        money.value(
                                            v-model="checkoutDrawer.form.payed"
                                            v-bind="checkoutDrawer.money"
                                            :class="{ invalid: parseFloat(checkoutDrawer.form.payed.toFixed(2)) < parseFloat(total.toFixed(2)) }"
                                        )
                                        .value.input {{ checkoutDrawer.numpad }}
                                    el-row
                                        el-button.exact-amount-payed(
                                            :type="parseFloat(checkoutDrawer.form.payed.toFixed(2)) === parseFloat(total.toFixed(2)) ? 'success' : 'info'"
                                            icon="el-icon-fa-hand-holding-usd fas"
                                            @click="checkoutDrawer.form.payed = total"
                                        ) {{ $t('Total amount') }}
                                .change
                                    .gray-box(v-if="(change = (total - checkoutDrawer.form.payed) * -1) && change > 0")
                                        label {{ $t('Change') }}
                                        .value {{ change | moneyFormat(currencyCode) }}
                .alert.warning(v-else)
                    p {{ $t('Missing payment methods') }}
            .drawer-footer
                el-button(
                    round
                    size="small"
                    icon="el-icon-fa-times fas"
                    @click="closeCheckoutDrawer"
                ) {{ $t('Dismiss') }}

                el-button-group
                    el-button(
                        round
                        size="small"
                        type="primary"
                        :plain="checkoutDrawer.numberOfPrints !== 0"
                        @click="updateNumberOfPrints(0)"
                    ) {{ $t("Don't print a receipt") }}
                    el-button(
                        round
                        size="small"
                        type="primary"
                        :plain="checkoutDrawer.numberOfPrints !== 1"
                        @click="updateNumberOfPrints(1)"
                    ) {{ $t('1x') }}
                    el-button(
                        round
                        size="small"
                        type="primary"
                        :plain="checkoutDrawer.numberOfPrints !== 2"
                        @click="updateNumberOfPrints(2)"
                    ) {{ $t('2x') }}

                el-button(
                    round
                    size="small"
                    :loading="checkoutDrawer.loading || checkoutDrawer.saving"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="! paymentMethods.length || ! validCheckout"
                    @click="createPurchase"
                ) {{ $t('Finish purchase') }}

        el-dialog.discount-modal(
            :title="$t('Change Price')"
            :visible.sync="discountModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="500px"
            @close="$emit('focus-search')"
            @closed="resetDiscountModal"
        )
            el-form.discount-modal-form(
                :model="discountModal.form"
                label-position="top"
                :rules="discountModal.rules"
                ref="discountModal"
                v-loading="discountModal.loading"
                @submit.prevent.native="saveDiscount"
            )
                .body(v-if="discountModal.form.item")
                    .info
                        .row
                            nobr.nr {{ discountModal.form.item.product_nr }}
                            nobr.name {{ discountModal.form.item.name }}
                            nobr.price(v-if="discountModal.form.item.price !== undefined") {{ discountModal.form.item.price | moneyFormat(currencyCode) }}
                        .row.properties
                            property-value(
                                v-for="property in discountModal.form.item.properties.filter(el => el.selectable)"
                                :key="property.id"
                                :property="property"
                            )
                        .row
                            nobr.sku
                                label {{ $t('SKU') }}:
                                span.value {{ discountModal.form.item.sku }}
                            //- transition(name="slide-decent-left")
                            //-     nobr.re-ordered(v-if="discountModal.form.item.pending_delivery_qty > 0")
                            //-         label {{ $t('Re-Ordered') }}:
                            //-         span.value {{ discountModal.form.item.pending_delivery_qty }}
                            //- nobr.qty
                            //-     label {{ $t('Quantity') }}:
                            //-     span.value {{ discountModal.form.item.qty }}
                    .prices.flex-row
                        .left.grow
                            //- .price-type-buttons
                            //-     button.sale-price-button(
                            //-         type="button"
                            //-         :class="{ active: discountModal.type === 'sale-price' }"
                            //-         @mousedown.prevent.stop="changeDiscountInputField('sale-price')"
                            //-     ) {{ $t('Sale Price') }}
                            //-     button.main-price-button(
                            //-         type="button"
                            //-         :class="{ active: discountModal.type === 'price' }"
                            //-         @mousedown.prevent.stop="changeDiscountInputField('price')"
                            //-     ) {{ $t('Price') }}
                            .main-price.contains-numpad
                                el-form-item.no-margin(:label="$t('Price')" prop="price")
                                    //- el-input.hidden(v-model="discountModal.form.price")
                                    //-     span(slot="append") {{ currencySymbol }}
                                    //- .el-input.el-input--medium.el-input-group
                                    //-     money.el-input__inner(
                                    //-         ref="mainPriceInput"
                                    //-         v-model="discountModal.form.price"
                                    //-         v-bind="discountModal.money"
                                    //-         @change.native="updateDiscountPercentage"
                                    //-     )
                                    //
                                    .gray-box.input
                                        .value.invisible {{ discountModal.form.price | moneyFormat(currencyCode) }}
                                        money.value(
                                            ref="mainPriceInput"
                                            v-model="discountModal.form.price"
                                            v-bind="discountModal.money"
                                            @change.native="updateDiscountPercentage"
                                            @focus.native="changeDiscountInputField('price')"
                                            @keydown.native="preventNegativeInput"
                                        )
                                        .value.input {{ discountModal.price_placeholder }}
                                    num-pad(
                                        ref="numpad"
                                        v-if="discountModal.type === 'price'"
                                        v-model="discountModal.form.price"
                                        :decimal-separator="discountModal.money.decimal"
                                        :thousands-separator="discountModal.money.thousands"
                                        @input="value => updateDiscountPercentage(value)"
                                        @update="value => discountModal.price_placeholder = value"
                                        type="float"
                                    )
                            .sale-price.contains-numpad
                                el-form-item.no-margin(:label="$t('Sale Price')" prop="sale_price")
                                    //- el-input.hidden(v-model="discountModal.form.sale_price")
                                    //-     span(slot="append") {{ currencySymbol }}
                                    //- .el-input.el-input--medium.el-input-group
                                    //-     money.el-input__inner(
                                    //-         ref="salePriceInput"
                                    //-         v-model="discountModal.form.sale_price"
                                    //-         v-bind="discountModal.money"
                                    //-         @change.native="updateDiscountPercentage"
                                    //-     )
                                    //
                                    .gray-box.input
                                        .value.invisible {{ discountModal.form.sale_price | moneyFormat(currencyCode) }}
                                        money.value(
                                            ref="salePriceInput"
                                            v-model="discountModal.form.sale_price"
                                            v-bind="discountModal.money"
                                            @change.native="updateDiscountPercentage"
                                            @focus.native="changeDiscountInputField('sale-price')"
                                            @keydown.native="preventNegativeInput"
                                        )
                                        .value.input {{ discountModal.sale_price_placeholder }}
                                    num-pad(
                                        ref="numpad"
                                        v-if="discountModal.type === 'sale-price'"
                                        v-model="discountModal.form.sale_price"
                                        :decimal-separator="discountModal.money.decimal"
                                        :thousands-separator="discountModal.money.thousands"
                                        @input="value => updateDiscountPercentage(value)"
                                        @update="value => discountModal.sale_price_placeholder = value"
                                        type="float"
                                    )
                        .right.percentages
                            //- :disabled="discountModal.form.percentage === percentage"
                            //- :type="discountModal.form.percentage === percentage ? 'primary' : 'info'"
                            //- :plain="discountModal.form.percentage !== percentage"
                            el-button(
                                v-for="percentage in discountModal.percentages"
                                :key="`discount-modal-percentage-${percentage}`"
                                size="large"
                                type="primary"
                                :plain="discountModal.form.percentage !== percentage"
                                :class="{ 'is-active': discountModal.form.percentage === percentage }"
                                @click="toggleDiscountPercentage(percentage, $event)"
                            ) {{ percentage }}%
                        //- .main-price.contains-numpad
                        //-     el-form-item.hide-label(:label="$t('Price')" prop="price")
                        //-         .gray-box.input
                        //-             .value.invisible {{ discountModal.form.price | moneyFormat(currencyCode) }}
                        //-             money.value(
                        //-                 ref="salePriceInput"
                        //-                 v-model="discountModal.form.price"
                        //-                 v-bind="discountModal.money"
                        //-                 @change.native="updateDiscountPercentage"
                        //-             )
                        //-             .value.input {{ discountModal.placeholder }}
                        //- .sale-price.contains-numpad
                        //-     el-form-item.hide-label(:label="$t('Sale Price')" prop="sale_price")
                        //-         //- el-input.hidden(v-model="discountModal.form.sale_price")
                        //-         //-     span(slot="append") {{ currencySymbol }}
                        //-         //- .el-input.el-input--medium.el-input-group
                        //-         //-     money.el-input__inner(
                        //-         //-         ref="salePriceInput"
                        //-         //-         v-model="discountModal.form.sale_price"
                        //-         //-         v-bind="discountModal.money"
                        //-         //-         @change.native="updateDiscountPercentage"
                        //-         //-     )
                        //-         //
                        //-         .gray-box.input
                        //-             .value.invisible {{ discountModal.form.sale_price | moneyFormat(currencyCode) }}
                        //-             money.value(
                        //-                 ref="salePriceInput"
                        //-                 v-model="discountModal.form.sale_price"
                        //-                 v-bind="discountModal.money"
                        //-                 @change.native="updateDiscountPercentage"
                        //-             )
                        //-             .value.input {{ discountModal.sale_price_placeholder }}
                        //-         num-pad(
                        //-             ref="numpad"
                        //-             v-model="discountModal.form.sale_price"
                        //-             :decimal-separator="discountModal.money.decimal"
                        //-             :thousands-separator="discountModal.money.thousands"
                        //-             @input="value => updateDiscountPercentage(value)"
                        //-             @update="value => discountModal.sale_price_placeholder = value"
                        //-             type="float"
                        //-         )
                        //-     .percentages
                        //-         //- :disabled="discountModal.form.percentage === percentage"
                        //-         //- :type="discountModal.form.percentage === percentage ? 'primary' : 'info'"
                        //-         //- :plain="discountModal.form.percentage !== percentage"
                        //-         el-button(
                        //-             v-for="percentage in discountModal.percentages" :key="percentage"
                        //-             size="large"
                        //-             type="primary"
                        //-             :plain="discountModal.form.percentage !== percentage"
                        //-             :class="{ 'is-active': discountModal.form.percentage === percentage }"
                        //-             @click="toggleDiscountPercentage(percentage, $event)"
                        //-         ) {{ percentage }}%
            .modal-footer(slot="footer")
                .left
                    transition(name="fade")
                        el-button(
                            v-if="discountModal.form.sale_price && discountModal.form.percentage"
                            size="small"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            :disabled="discountModal.loading"
                            @click="deleteDiscount"
                        ) {{ $t('Remove Discount') }}
                .right
                    el-button(
                        size="small"
                        icon="el-icon-fa-times fas"
                        :disabled="discountModal.loading"
                        @click="closeDiscountModal"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        size="small"
                        type="success"
                        icon="el-icon-fa-check fas"
                        :disabled="discountModal.loading"
                        @click="saveDiscount"
                    ) {{ $t('Save') }}

        el-dialog.discount-modal(
            :title="$t('Discount total')"
            :visible.sync="totalDiscountModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="630px"
            @close="$emit('focus-search')"
            @closed="resetTotalDiscountModal"
        )
            el-form.discount-modal-form(
                :model="totalDiscountModal.form"
                label-position="top"
                :rules="totalDiscountModal.rules"
                ref="totalDiscountModal"
                v-loading="totalDiscountModal.loading"
                @submit.prevent.native="saveTotalDiscount"
            )
                .body.flex-row
                    .left(style="width: 300px")
                        label {{ $t('Total without discount')+': ' }}
                        b.value {{ total | moneyFormat(currencyCode) }}
                        p.mt-2(v-if="totalDiscountModal.form.percentage") {{ $t('Discount in percentage')+': '+totalDiscountModal.form.percentage+" %" }}
                        .sale-price.contains-numpad
                            el-form-item(:label="$t('Sale Price')" prop="sale_price")
                                .gray-box.input
                                    .value.invisible {{ totalDiscountModal.form.sale_price | moneyFormat(currencyCode) }}
                                    money.value(
                                        ref="totalSalePriceInput"
                                        v-model="totalDiscountModal.form.sale_price"
                                        v-bind="totalDiscountModal.money"
                                        @change.native="updateTotalDiscountPercentage"
                                        @keydown.native="preventNegativeInput"
                                    )
                                    .value.input {{ totalDiscountModal.placeholder }}
                                num-pad(
                                    ref="numpad"
                                    v-model="totalDiscountModal.form.sale_price"
                                    :decimal-separator="totalDiscountModal.money.decimal"
                                    :thousands-separator="totalDiscountModal.money.thousands"
                                    @input="value => updateTotalDiscountPercentage(value)"
                                    @update="value => totalDiscountModal.placeholder = value"
                                    type="float"
                                )
                    .right.flex-row
                        .total-percentages
                            el-button(
                                v-for="percentage in totalDiscountModal.percentages"
                                :key="`total-discount-modal-percentage-${percentage}`"
                                size="large"
                                type="primary"
                                :plain="totalDiscountModal.form.percentage !== percentage"
                                :class="{ 'is-active': totalDiscountModal.form.percentage === percentage }"
                                @click="toggleTotalDiscountPercentage(percentage, $event)"
                            ) {{ percentage }}%
                        .roundings
                            el-button(
                                v-for="rounding in totalDiscountModal.roundings"
                                :key="`total-discount-modal-roundings-${rounding}`"
                                size="large"
                                type="primary"
                                :plain="parseFloat(totalDiscountModal.form.sale_price) !== parseFloat(rounding)"
                                :class="{ 'is-active': parseFloat(totalDiscountModal.form.sale_price) === parseFloat(rounding) }"
                                @click="setTotalRounding(rounding, $event)"
                            ) {{ rounding | moneyFormat(currencyCode) }}
            .modal-footer(slot="footer")
                .left
                    transition(name="fade")
                        el-button(
                            v-if="totalDiscountModal.form.percentage"
                            size="small"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            :disabled="totalDiscountModal.loading"
                            @click="deleteTotalDiscount"
                        ) {{ $t('Remove Discount') }}
                .right
                    el-button(
                        size="small"
                        icon="el-icon-fa-times fas"
                        :disabled="totalDiscountModal.loading"
                        @click="closeTotalDiscountModal"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        size="small"
                        type="success"
                        icon="el-icon-fa-check fas"
                        :disabled="totalDiscountModal.loading"
                        @click="saveTotalDiscount"
                    ) {{ $t('Save Discount') }}

        el-dialog.qrcode-modal(
            :title="$t('QR code link to receipt download')"
            :visible.sync="qrCodeModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="500px"
            @closed="resetQrCodeModal"
            v-loading="qrCodeModal.loading"
        )
            canvas(ref="qrcanvas")
            el-button(
                @click="qrCodeModal.visibility = false"
                ) {{ $t('close') }}

        el-drawer.previously-purchased-items-drawer(
            :title="$t('Previously purchased items by {name}', { name: purchaser.name })"
            :visible.sync="previouslyPurchasedItemsDrawer.visibility"
            :modal="true"
            size="50%"
            @close="resetPreviouslyPurchasedItemsDrawer"
        )
            .drawer-body(
                v-if="previouslyPurchasedItemsDrawer.visibility"
                v-loading="previouslyPurchasedItemsDrawer.loading"
            )
                previously-purchased-items(
                    :customer="purchaser.customer"
                    :initializing.sync="previouslyPurchasedItemsDrawer.loading"
                    @create-coupon="createCoupon"
                    @ask-for-refund="askForRefund"
                    @update-visibility="value => previouslyPurchasedItemsDrawer.visibility = value"
                    @blur-search="$emit('blur-search')"
                )
</template>

<i18n>
{
    "en": {
        "Previously purchased items by {name}": "Previously purchased items by {name}",
        "Remaining coupon value: {name} ({code})": "Remaining coupon value: {name} ({code})"
    },
    "de": {
        "inactive": "inaktiv",
        "Article": "Artikel",
        "Price": "Einzelpreis",
        "Quantity": "Anzahl",
        "Quantity Sum": "Anzahl",
        "Total": "Gesamt",
        "Total without discount": "Gesamt ohne Rabatt",
        "Discount in percentage": "Rabatt in Prozent",
        "Round down to next position": "Abrunden auf nächste Stelle",
        "Stocks": "Bestände",
        "Available": "Verfügbar",
        "Stock": "Lager",
        "request 1x": "1x anfordern",
        "take back 1x": "1x zurücknehmen",
        "Customer": "Kunde",
        "Add customer": "Neuen Kunden erstellen",

        "Gender": "Geschlecht",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Password": "Passwort",
        "Customer Group": "Kundengruppe",
        "Phone": "Telefon",
        "Company": "Firma",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt",
        "Address": "Adresse",
        "Street": "Straße",
        "Zipcode": "PLZ",
        "City": "Ort",
        "Country": "Land",

        "Save": "Speichern",
        "Select": "Auswählen",
        "Put Aside": "Zurücklegen",
        "Sellable From/To": "Verkaufbar ab/bis",
        "From": "Ab",
        "Disabled in the stock settings": "In den Lagereinstellungen deaktiviert",
        "Sold out": "Ausverkauft",
        "To": "Bis",
        "Change Price": "Preis anpassen",
        "Discount": "Rabatt",
        "Discount total": "Rabatt Gesamtsumme",
        "Save Discount": "Rabatt speichern",
        "Remove Discount": "Rabatt entfernen",
        "Re-Ordered": "Im Zulauf",
        "Sale Price": "Sonderpreis",
        "missing": "fehlt",
        "Payed": "Bezahlt",
        "Change": "Rückgeld",
        "Remaining amount": "Restbetrag",
        "Transfer the remaining amount to the next payment method": "Übertrage den Restbetrag auf die nächste Zahlungsmethode",
        "Transfer the remaining amount": "Übertrage den Restbetrag",
        "transfer": "übertragen",
        "Guest": "Gast",
        "Coupons": "Gutscheine",
        "Apply coupon": "Gutschein anwenden",
        "Apply another coupon": "Wieteren Gutschein anwenden",
        "Coupon not found": "Gutschein konnte nicht gefunden werden",
        "Coupon applied successfully!": "Gutschein erfolgreich angewendet!",
        "Coupon has already been applied": "Coupon wurde bereits angewendet",
        "Nothing Scanned": "Keine Ware erfasst",
        "Where the heck are the customers?": "Wo bleiben die Kunden?",
        "No customers found": "Keine Kunden gefunden",
        "Previously purchased items by {name}": "Zuvor gekaufte Artikel von {name}",
        "Checkout": "Kasse",
        "Subtotal": "Zwischensumme",
        "Articles": "Artikel",
        "Finish purchase": "Kauf abschließen",
        "Total amount": "Gesamtbetrag",
        "Payment method": "Zahlungsart",
        "Split payment": "Split-Zahlung",
        "Missing payment methods": "keine Zahlungsarten vorhanden",
        "Shopping cart could not be saved.": "Warenkorb konnte nicht gespeichert werden.",
        "Shopping cart saved successfully.": "Warenkorb erfolgreich gespeichert.",
        "Clear Shopping Cart": "Warenkorb leeren",
        "Do you really want to clear the shopping cart?": "Möchten Sie den Warenkorb wirklich leeren?",
        "Clear Cart": "Warenkorb leeren",
        "Purchase completed successfully!": "Verkauf erfolgreich abgeschlossen!",
        "Purchase could not be completed.": "Verkauf konnte nicht abgeschlossen werden.",
        "Purchase could not be completed because the fiscal security device (TSE) is not available. Please try again later.": "Verkauf konnte nicht abgeschlossen werden, da die technische Sicherheitseinrichtung (TSE) nicht erreichbar ist. Bitte versuchen Sie es später erneut.",
        "Article requested successfully!": "Artikel wurde erfolgreich angefordert!",
        "Article could not be requested.": "Artikel konnte nicht angefordert werden.",
        "Could not print the shipping package slip!": "Kassenbon konnte nicht gedruckt werden!",
        "Don't print a receipt": "Kassenbon nicht drucken",
        "Selected" : "Ausgewählt",
        "Please select at least one article in a stock.": "Bitte wählen Sie mindestens eine Artikelanzahl in einem Lager aus.",
        "Done": "Fertig",
        "Edit quantities per stock": "Anzahl pro Lager auswählen",
        "QR code link to receipt download": "QR-Code zum Download des Kassenbons",
        "close": "Schließen",
        "Pay out remaining value": "Restwert auszahlen",
        "Remaining coupon value: {name} ({code})": "Gutschein-Restwert: {name} ({code})",
        "Remaining value": "Restwert"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';
import printJS from 'print-js-updated';

import { fromUnixTime, isFuture, isPast } from 'date-fns'
import { appFromUnixTime } from '@/utils/timezone'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import { useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores'
import { moneyFormat, timestamp2date } from '@/filters'

import { Money } from 'v-money'
import QRCode from 'qrcode'

import AuthApi from '@/store/api/system/auth'
import ArticleApi from '@/extensions/shop/store/api/article';
import MemberApi from '@/extensions/restrictedArea/store/api/member';
import CouponApi from '@/extensions/shop/pointOfSale/store/api/coupon'
import FileApi from '@/store/api/cms/file';

import NumPad from '@/components/NumPad'
import Keyboard from '@/components/Keyboard'
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import PreviouslyPurchasedItems from './PreviouslyPurchasedItems'
import ItemMediaPreview from './ItemMediaPreview'
import CouponList from './CouponList'

export default {
    name: 'POS_ShoppingCart',
    data: () => ({
        stocksModal: {
            visibility: false,
            loading: false,
            item: undefined,
        },
        stocksModalEdit: {
            visibility: false,
            loading: false,
            availableStocks: [],
            item: undefined,
        },
        discountModal: {
            visibility: false,
            loading: false,
            percentages: [3, 5, 10, 20, 30, 40, 50, 60, 70],
            numpad: '',
            type: 'sale-price', // 'sale-price' or 'price'
            sale_price_placeholder: '',
            price_placeholder: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            form: {
                item: undefined,
                percentage: undefined,
                price: undefined, // for 'price' type
                sale_price: undefined, // for 'sale-price' type
            },
            rules: {}
        },
        totalDiscountModal: {
            visibility: false,
            loading: false,
            percentages: [3, 5, 10, 20, 30, 40, 50, 60, 70],
            roundings: [],
            numpad: '',
            placeholder: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            form: {
                percentage: undefined,
                sale_price: undefined,
            },
            rules: {}
        },
        checkoutDrawer: {
            visibility: false,
            saving: false,
            loading: false,
            split: false,
            numpad: '',
            numberOfPrints: 1,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            form: {
                payed: 0,
                paymentMethod: undefined
            }
        },
        customerSearchPopover: {
            visibility: false,
            saving: false,
            loading: false,
            active: false,
            form: {
                input: '',
            },
            newMember: {
                visibility: false,
                saving: false,
                loading: false,
                focusedField: undefined,
                form: {
                    gender: undefined,
                    first_name: '',
                    last_name: '',
                    mobile: '',
                    phone: '',
                    email: '',
                    // password: '',
                    address: {
                        street: '',
                        zipcode: '',
                        city: '',
                        country: '',
                    },
                    memberTags: [],
                },
                rules: {
                    gender: 'required',
                    first_name: 'required',
                    last_name: 'required',
                    email: 'required|email',
                    // email: `required|email|unique_member_email:"cms":${this.activeCms.id}`,
                    // address: {
                    //     street: 'required',
                    //     zipcode: 'required',
                    //     city: 'required',
                    //     country: 'required',
                    // },
                }
            },
            pagination: {
                filters: {},
                pageInfo: {
                    total: 0,
                    perPage: 12,
                    currentPage: 1,
                    lastPage: 0,
                },
                items: []
            }
        },
        couponSearchPopover: {
            visibility: false,
            saving: false,
            loading: false,
            active: false,
            form: {
                input: '',
            },
        },
        qrCodeModal: {
            visibility: false,
            loading: false,
            latestReceipt: null
        },
        previouslyPurchasedItemsDrawer: {
            visibility: false,
            loading: false,
        },
        puttingCartAside: false,
        showClearCartDialog: false,
        returnRemainingCouponAmountAsCash: false,
    }),
    components: {
        PropertyValue,
        ItemMediaPreview,
        PreviouslyPurchasedItems,
        CouponList,
        NumPad,
        Keyboard,
        Money
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        posSetupStore() {
            return usePosSetupStore()
        },
        posCartStore() {
            return usePosCartStore()
        },
        customerKeyboardInput: {
            get() {
                let field = this.customerSearchPopover.focusedField
                if (this.customerSearchPopover.newMember.visibility === true && field) {
                    if (field.startsWith('address')) {
                        field = field.replace('address.', '')
                        return _.get(this.customerSearchPopover.newMember.form.address, field)
                    } else {
                        return _.get(this.customerSearchPopover.newMember.form, field)
                    }
                } else {
                    return this.customerSearchPopover.form.input
                }
            },
            set(value) {
                let field = this.customerSearchPopover.focusedField
                if (this.customerSearchPopover.newMember.visibility && field) {
                    if (field.startsWith('address')) {
                        field = field.replace('address.', '')
                        this.$set(this.customerSearchPopover.newMember.form.address, field, value)
                    } else {
                        this.$set(this.customerSearchPopover.newMember.form, field, value)
                    }
                } else {
                    this.customerSearchPopover.form.input = value
                }
            },
        },
        dirty() {
            let dirty = false

            if (!dirty && this.purchaseID) dirty = true
            if (!dirty && this.items.length) dirty = true
            if (!dirty && this.coupons.length) dirty = true
            if (!dirty && this.purchaser.customer) dirty = true

            return dirty
        },
        countries() {
            return countries.getNames('de')
        },
        totalModalQty() {
            return this.stocksModalEdit.availableStocks.reduce((pv, cv) => pv + cv.qty, 0)
        },
        splitPaymentFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'pos:split-payment');
        },
        currencyCode() {
            return _.get(this.currency, 'iso4217') || 'EUR'
        },
        currencySymbol() {
            return _.get(this.currency, 'sign') || '€'
        },
        paymentMethods() {
            return this.options.paymentMethod.items
        },
        containsUnsavableItems() {
            return this.items.some(item => item.manage_stock && this.getAvailableQty(item) <= 0)
        },
        validCheckout() {
            let valid = true;
            const paymentMethod = _.get(this.checkoutDrawer.form, 'paymentMethod')
            if (paymentMethod && paymentMethod.digital === false
                && parseFloat(this.checkoutDrawer.form.payed.toFixed(2)) < parseFloat(this.total.toFixed(2))) {
                valid = false;
            }
            if (this.checkoutDrawer.split
                && parseFloat(this.checkoutDrawer.form.payed.toFixed(2)) < parseFloat(this.total.toFixed(2))) {
                valid = false;
            }
            // return (paymentMethod && paymentMethod.digital === true)
            //     || (paymentMethod && paymentMethod.digital === false && parseFloat(this.checkoutDrawer.form.payed.toFixed(2)) >= parseFloat(this.total.toFixed(2)))

            return valid;
        },
        hasEligibleRemainingAmountCoupon() {
            // Check if there's a fixed coupon that could have remaining amount
            // Criteria: type === 'fixed' && discard_remaining_amount === false && coupon.amount > total
            // AND (max_uses === 1 OR max_uses_per_customer >= 1) - meaning it's a single-use coupon
            return this.coupons.some(coupon =>
                !coupon.disabled &&
                coupon.type === 'fixed' &&
                coupon.discard_remaining_amount === false &&
                coupon.amount > this.total &&
                (coupon.max_uses === 1 || (coupon.max_uses_per_customer && coupon.max_uses_per_customer >= 1))
            );
        },
        estimatedRemainingCouponValue() {
            // Calculate the estimated remaining value from eligible coupons
            // Use subTotal (actual article total) not total (which is after coupon discount)
            const eligibleCoupon = this.coupons.find(coupon =>
                !coupon.disabled &&
                coupon.type === 'fixed' &&
                coupon.discard_remaining_amount === false &&
                coupon.amount > this.subTotal &&
                (coupon.max_uses === 1 || (coupon.max_uses_per_customer && coupon.max_uses_per_customer >= 1))
            );
            if (!eligibleCoupon) return 0;
            return eligibleCoupon.amount - this.subTotal;
        },
        purchaseID() {
            return this.posCartStore.id;
        },
        items() {
            return this.posCartStore.items;
        },
        purchaser() {
            return this.posCartStore.purchaser;
        },
        coupons() {
            return this.posCartStore.coupons;
        },
        applicableCustomerCoupons() {
            return this.posCartStore.applicableCustomerCoupons;
        },
        qtySum() {
            return this.posCartStore.qtySum;
        },
        subTotal() {
            return this.posCartStore.subTotal;
        },
        discount() {
            return this.posCartStore.discount;
        },
        total() {
            return this.posCartStore.total;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        currency() {
            return this.posSetupStore.currency;
        },
        options() {
            return this.posSetupStore.options;
        }
    },
    methods: {
        isInactive(item) {
            var articleStatus = _.get(item, 'article.status');
            var productStatus = _.get(item, 'article.product.status');
            return articleStatus !== 'enabled' || productStatus !== 'enabled';
        },
        isFuture(timestamp) {
            return isFuture(appFromUnixTime(timestamp))
        },
        isPast(timestamp) {
            return isPast(appFromUnixTime(timestamp))
        },
        // getCurrency(item) {
        //     return _.get(item, 'price.customerGroup.currency.iso4217')
        //         || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        // },
        clearCart() {
            this.reset()
            this.load().finally(() => this.save())

            this.showClearCartDialog = false
        },
        async putCartAside() {
            this.puttingCartAside = true

            const payload = {
                id: this.purchaseID,
                shop: { id: this.activeCms.shop.id },
                purchaser: this.purchaser,
                coupons: _.cloneDeep(this.coupons).filter(coupon => !coupon.disabled).map(el => {
                    return { id: el.id, code: el.code }
                }),
                items: _.cloneDeep(this.items).map(el => {
                    el.propertyValueOptions = el.properties.map(prop => prop.valueOption)
                    el.article = { id: el.article.id } // full article highly impacts performance
                    delete el.properties
                    return el
                }),
            }

            const purchase = await this.sellLater(payload)
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Shopping cart could not be saved.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })

            this.puttingCartAside = false

            if (purchase && purchase.errors && purchase.errors.length) {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Shopping cart could not be saved.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }

            if (purchase && parseInt(purchase.id) > 0) {
                this.$notify.success({
                    title: this.$t('Shopping cart saved successfully.'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })

                this.reset()
                this.load().finally(() => this.save())
            }
        },
        createCoupon(amount) {
            this.$emit('create-coupon', amount)
            setTimeout(async () => {
                this.previouslyPurchasedItemsDrawer.visibility = false
                await this.$nextTick()
                this.updateAutofocusSearchInput(false)
                this.$emit('blur-search')
            }, 100)
        },
        askForRefund(data) {
            this.$emit('ask-for-refund', data)
            setTimeout(async () => {
                this.previouslyPurchasedItemsDrawer.visibility = false
                await this.$nextTick()
                this.updateAutofocusSearchInput(false)
                this.$emit('blur-search')
            }, 100)
        },
        getRelevantArticleStocks(article) {
            const stocks = article.stocks || []

            const posStockOptions = this.activePointOfSale.stocks || []
            const stockIds = posStockOptions.map(e => e.id)
            const posStocks = stocks.filter(el => stockIds.includes(el.id))

            const stockIDs = posStocks.map(el => el.id)

            // sort by priority_pos
            return stocks.filter(el => el.pivot.qty > 0 && stockIDs.includes(el.id))
                .sort((a, b) => b.priority_pos - a.priority_pos)
        },
        getAvailableQty(item) {
            let availableQty;

            if (item.manage_stock) {
                const stocks = this.getRelevantArticleStocks(item.article)
                availableQty = stocks.reduce((pv, stock) => pv + _.get(stock, 'pivot.qty', 0), 0)
            }

            return availableQty;
        },
        saveQtyEditModal() {
            this.stocksModalEdit.availableStocks.forEach(el => {
                this.updateItemQuantities({ item: this.stocksModalEdit.item, qty: el.qty, stock: el })
            })
            this.save()

            this.stocksModalEdit.visibility = false
        },
        closeQtyEditModal() {
            this.stocksModalEdit.visibility = false
        },
        getTotalItemQty(item) {
            let totalItemQty = 0;
            if (item.manage_stock && item.quantities) item.quantities.forEach(el => totalItemQty += el.qty)
            else if (!item.manage_stock) totalItemQty += item.qty
            return totalItemQty;
        },
        putArticleAside(item) {
            // TODO
        },
        async showCustomerPurchaseHistory() {
            this.previouslyPurchasedItemsDrawer.visibility = true
            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')
        },
        resetPreviouslyPurchasedItemsDrawer() {
            this.previouslyPurchasedItemsDrawer = {
                visibility: false,
            }

            this.updateAutofocusSearchInput(true)
            // this.$emit('focus-search')
        },
        async showStocks(item) {
            this.stocksModal.item = _.cloneDeep(item)
            this.stocksModal.visibility = true
            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')

            if (this.stocksModal.item.article) {
                this.stocksModal.loading = true
                const id = parseInt(this.stocksModal.item.article.id)
                const shopID = parseInt(this.activeCms.shop.id)
                const article = await ArticleApi.fetchArticle(id, shopID);
                if (article) {
                    this.stocksModal.item.article = article
                    this.updateArticleStocks(article)
                    this.save()
                }
                this.stocksModal.loading = false
            }
        },
        async showStocksEdit(item) {

            this.stocksModalEdit.item = _.cloneDeep(item)
            this.stocksModalEdit.visibility = true
            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')

            const stocks = this.activePointOfSale.stocks || []
            const stockIds = stocks.map(e => e.id)
            this.stocksModalEdit.availableStocks = this.stocksModalEdit.item.article.stocks
                .filter(el => {
                    return el.pivot.qty > 0 && stockIds.includes(el.id)
                })
                .sort((a, b) => b.priority_pos - a.priority_pos)
                .map(el => {
                    const quantity = item.quantities.find(quantity => quantity.stock.id == el.id)
                    el.qty = _.get(quantity, 'qty')
                    return el
                })

            if (this.stocksModalEdit.item.article) {
                this.stocksModalEdit.loading = true
                const id = parseInt(this.stocksModalEdit.item.article.id)
                const shopID = parseInt(this.activeCms.shop.id)
                const article = await ArticleApi.fetchArticle(id, shopID);
                if (article) {
                    this.stocksModalEdit.item.article = article
                    this.updateArticleStocks(article)
                    this.save()
                }
                this.stocksModalEdit.loading = false
            }
        },
        updateStocksModalEditQty(s, qty) {
            const availableStocks = _.cloneDeep(this.stocksModalEdit.availableStocks)
            availableStocks[s].qty = qty
            this.$set(this.stocksModalEdit, 'availableStocks', availableStocks)
        },
        closeStockModal() {
            this.stocksModal.visibility = false
            this.updateAutofocusSearchInput(true)
        },
        resetStockModal() {
            this.stocksModal = {
                visibility: false,
                loading: false,
                item: undefined,
            }
            this.updateAutofocusSearchInput(true)
        },
        resetStockModalEdit() {
            this.stocksModalEdit = {
                visibility: false,
                loading: false,
                availableStocks: [],
                item: undefined,
            }
            this.updateAutofocusSearchInput(true)
        },
        requestArticle(stock) {
            this.$set(stock, 'loading', true)

            const handleError = () => {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Article could not be requested.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }

            this.requestArticles({
                shop: this.activeCms.shop,
                items: [{
                    id: this.stocksModal.item.id,
                    qty: 1,
                    stocks: [{ id: stock.id }],
                    article: { id: this.stocksModal.item.article.id },
                    propertyValueOptions: this.stocksModal.item.properties.map(prop => prop.valueOption)
                }],
            })
                .then(purchase => {
                    if (purchase.errors && purchase.errors.length) {
                        handleError()
                    } else {
                        this.$notify.success({
                            title: this.$t('Article requested successfully!'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)
                    handleError()
                })
                .finally(() => {
                    this.$delete(stock, 'loading')
                })
        },

        askForDiscount(item) {
            this.discountModal.money.suffix = ` ${this.currencySymbol}`
            this.discountModal.form.item = _.cloneDeep(item)
            this.discountModal.form.price = this.discountModal.form.item.price

            // this.discountModal.form.sale_price = this.discountModal.form.item.sale_price || this.discountModal.form.item.price
            this.discountModal.form.sale_price = 0
            if (this.discountModal.form.item.sale_price && this.discountModal.form.item.price != this.discountModal.form.item.sale_price) {
                this.discountModal.form.sale_price = this.discountModal.form.item.sale_price
            }

            this.discountModal.rules = {
                price: `required|min_value:0.01`,
                // sale_price: `required|min_value:0.01|max_value:${item.price}`
                // sale_price: `required|min_value:0.01`
            }
            if (this.discountModal.form.item.sale_price) {
                const percentage = (this.discountModal.form.item.price - this.discountModal.form.item.sale_price) / this.discountModal.form.item.price * 100
                this.discountModal.form.percentage = _.round(percentage, 2)
            }
            this.discountModal.visibility = true
            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')

            this.$nextTick(() => {
                this.$refs.salePriceInput.$el.focus()
            })
        },
        askForTotalDiscount(item) {

            this.totalDiscountModal.roundings = []

            // if (this.total !== _.floor(this.total, 1)) {
            //     this.totalDiscountModal.roundings.push(_.floor(this.total, 1))
            // }
            // if (this.total !== _.floor(this.total)) {
            //     this.totalDiscountModal.roundings.push(_.floor(this.total))
            // }
            // let stringNumber = _.floor(this.total) + ''
            // const length = (_.floor(this.total) + '').length
            // let count = 1
            // while (count < length) {
            //     let subNumber = stringNumber.substring(0, length - count)
            //     let nulls = '0'.repeat(count)
            //     let roundingNumber = subNumber + nulls
            //     if (parseFloat(this.total) !== parseFloat(roundingNumber)) this.totalDiscountModal.roundings.push(subNumber + nulls)
            //     count++
            // }

            const total = Number(this.total);
            const roundingsSet = new Set();

            // Runde auf eine Nachkommastelle ab
            const floor1 = Math.floor(total * 10) / 10;
            if (total !== floor1) roundingsSet.add(floor1);

            // Runde auf ganze Zahl ab
            const floor0 = Math.floor(total);
            if (total !== floor0) roundingsSet.add(floor0);

            // Weitere Rundungen (z.B. Zehner, Hunderter, ...)
            let str = String(floor0);
            for (let i = 1; i < str.length; i++) {
                let sub = str.substring(0, str.length - i);
                if (sub.length === 0) continue;
                let zeros = '0'.repeat(i);
                let num = Number(sub + zeros);
                if (total !== num) roundingsSet.add(num);
            }

            this.totalDiscountModal.roundings = Array.from(roundingsSet);

            if (!this.totalDiscountModal.form.sale_price) this.totalDiscountModal.form.sale_price = this.total
            this.totalDiscountModal.rules = {
                sale_price: `required|min_value:0.01`
            }
            if (this.totalDiscountModal.form.sale_price) {
                const percentage = (this.total - this.totalDiscountModal.form.sale_price) / this.total * 100
                this.totalDiscountModal.form.percentage = _.round(percentage, 2)
                // console.log("percentage", percentage)
            }

            this.totalDiscountModal.visibility = true

            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')

            this.$nextTick(() => {
                this.$refs.totalSalePriceInput.$el.focus()
            })
        },
        toggleDiscountPercentage(percentage, event) {
            event.target.blur()

            const price = this.discountModal.form.price || this.discountModal.form.item.price

            if (this.discountModal.form.percentage && this.discountModal.form.percentage === percentage) {
                this.discountModal.form.percentage = undefined
                this.discountModal.form.sale_price = this.discountModal.form.item.sale_price || price
            } else {
                this.discountModal.form.percentage = _.round(percentage, 2)
                this.discountModal.form.sale_price = price / 100 * (100 - percentage)
            }

            this.discountModal.sale_price_placeholder = this.discountModal.form.sale_price
        },
        toggleTotalDiscountPercentage(percentage, event) {
            event.target.blur()

            if (this.totalDiscountModal.form.percentage && this.totalDiscountModal.form.percentage === percentage) {
                this.totalDiscountModal.form.percentage = undefined
                this.totalDiscountModal.form.sale_price = this.total
            } else {
                this.totalDiscountModal.form.percentage = _.round(percentage, 2)
                this.totalDiscountModal.form.sale_price = this.total / 100 * (100 - percentage)
            }

            this.totalDiscountModal.placeholder = this.totalDiscountModal.form.sale_price
        },
        async changeDiscountInputField(type) {
            this.discountModal.type = type
            await this.$nextTick()
            switch (type) {
                case 'sale-price':
                    this.$refs.salePriceInput.$el.focus()
                    break;
                case 'price':
                    this.$refs.mainPriceInput.$el.focus()
                    break;
            }
        },
        setTotalRounding(rounding, event) {
            event.target.blur()
            this.totalDiscountModal.form.sale_price = parseFloat(rounding)

        },
        updateDiscountPercentage() {
            const price = this.discountModal.form.price || this.discountModal.form.item.price

            // Prevent sale price from exceeding regular price
            if (this.discountModal.form.sale_price > price) {
                this.discountModal.form.sale_price = price
                this.discountModal.sale_price_placeholder = this.$options.filters.moneyFormat(price, this.currencyCode)
            }

            const percentage = (price - this.discountModal.form.sale_price) / price * 100
            this.discountModal.form.percentage = _.round(percentage, 2)

            if (this.discountModal.type === 'sale-price') {
                this.$refs.salePriceInput.$el.focus()
            }

            if (this.discountModal.type === 'price') {
                this.$refs.mainPriceInput.$el.focus()
            }
        },
        preventNegativeInput(event) {
            if (event.key === '-' || event.key === 'Subtract') {
                event.preventDefault()
            }
        },
        updateTotalDiscountPercentage() {
            const percentage = (this.total - this.totalDiscountModal.form.sale_price) / this.total * 100
            this.totalDiscountModal.form.percentage = _.round(percentage, 2)

            this.$refs.totalSalePriceInput.$el.focus()
        },
        saveDiscount() {
            this.$refs.discountModal.validate((valid, errors) => {
                if (valid) {
                    let item = _.cloneDeep(this.discountModal.form.item)

                    // if (this.discountModal.form.sale_price < item.price) {
                    //     item.sale_price = this.discountModal.form.sale_price
                    // } else {
                    //     item.sale_price = undefined
                    // }

                    item.price = this.discountModal.form.price
                    item.sale_price = this.discountModal.form.sale_price || undefined

                    this.updateItem(item)
                    this.save()
                    this.closeDiscountModal()
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        async saveTotalDiscount() {
            this.totalDiscountModal.loading = true

            this.$refs.totalDiscountModal.validate(async (valid, errors) => {
                if (valid) {
                    //>>> request total discount coupon and apply
                    if (this.totalDiscountModal.form.sale_price && this.totalDiscountModal.form.sale_price !== this.total) {
                        const amount = this.total - this.totalDiscountModal.form.sale_price
                        const totalDiscountCoupon = {
                            id: uniqid('new:'),
                            name: undefined,
                            description: undefined,
                            code: uniqid(`POS-${this.activePointOfSale.id}-`).toUpperCase(),
                            position: undefined,
                            type: 'fixed',
                            max_uses: 1,
                            max_uses_per_customer: undefined,
                            percentage: undefined,
                            amount,
                            start_at: undefined,
                            end_at: undefined,
                            discard_the_following_coupons: false,
                            discard_remaining_amount: false,
                            shop: this.activeCms.shop
                        }

                        const coupon = await CouponApi.create({
                            coupon: totalDiscountCoupon,
                            pointOfSale: this.activePointOfSale,
                            print: false,
                        })
                            .catch(error => {
                                console.error(error)
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Coupon could not be created.'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000,
                                })
                            });

                        this.applyTotalDiscountCoupon(coupon.code)
                    }

                    this.totalDiscountModal.loading = false
                    this.totalDiscountModal.visibility = false
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                    this.totalDiscountModal.loading = false
                }
            });
        },
        deleteDiscount() {
            this.discountModal.form.percentage = undefined
            this.discountModal.form.sale_price = this.discountModal.form.item.price
            // this.discountModal.form.sale_price = undefined
            this.saveDiscount()
        },
        deleteTotalDiscount() {
            this.totalDiscountModal.form.percentage = undefined
            this.totalDiscountModal.form.sale_price = this.total
            // this.totalDiscountModal.form.sale_price = undefined
        },
        closeDiscountModal() {
            this.discountModal.visibility = false
            this.updateAutofocusSearchInput(true)
        },
        closeTotalDiscountModal() {
            this.totalDiscountModal.visibility = false
            this.updateAutofocusSearchInput(true)
        },
        resetDiscountModal() {
            this.discountModal = {
                type: 'sale-price', // 'sale-price' or 'price'
                visibility: false,
                loading: false,
                percentages: [3, 5, 10, 20, 30, 40, 50, 60, 70],
                numpad: '',
                sale_price_placeholder: '',
                price_placeholder: '',
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                form: {
                    item: undefined,
                    percentage: undefined,
                    price: undefined, // for 'price' type
                    sale_price: undefined, // for 'sale-price' type
                },
                rules: {}
            }
            this.updateAutofocusSearchInput(true)
        },
        resetTotalDiscountModal() {
            this.totalDiscountModal = {
                visibility: false,
                loading: false,
                percentages: [3, 5, 10, 20, 30, 40, 50, 60, 70],
                roundings: [],
                numpad: '',
                placeholder: '',
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                form: {
                    percentage: undefined,
                    sale_price: undefined,
                },
                rules: {}
            }
            this.updateAutofocusSearchInput(true)
        },
        updateItemQty(item, qty) {
            if (item.manage_stock && item.quantities && item.quantities.length) {
                const stock = item.quantities[0].stock
                this.updateItemQuantities({ item, qty, stock })
            } else {
                this.updateItemQtyMutation({ item, qty })
            }
            this.save()
        },
        deleteItem(item) {
            this.deleteItemMutation(item)
            this.save()
        },

        updateNumberOfPrints(value) {
            localStorage.setItem('number-of-receipts-to-be-printed', value)
            this.checkoutDrawer.numberOfPrints = value
        },
        checkout() {
            let paymentMethod
            if (this.paymentMethods.length) {
                paymentMethod = this.paymentMethods.find(el => el.default)
                    || this.paymentMethods.find(el => el.digital === false)
                    || this.paymentMethods[0]
            }

            this.checkoutDrawer.numberOfPrints = parseInt(localStorage.getItem('number-of-receipts-to-be-printed') || 1);

            this.checkoutDrawer.numpad = '0'
            this.checkoutDrawer.money.suffix = ` ${this.currencySymbol}`
            this.checkoutDrawer.form.paymentMethod = paymentMethod
            this.checkoutDrawer.visibility = true
            this.updateAutofocusSearchInput(false)
            this.$emit('blur-search')
        },
        updateCheckoutPaymentMethod(paymentMethod) {
            this.checkoutDrawer.split = false
            this.checkoutDrawer.numpad = ''
            this.checkoutDrawer.form.payed = 0
            this.checkoutDrawer.form.paymentMethod = paymentMethod
        },
        selectSplitPayment() {
            if (this.splitPaymentFeatureEnabled && this.paymentMethods.length > 1) {
                this.checkoutDrawer.numpad = ''
                this.checkoutDrawer.form.payed = 0
                this.checkoutDrawer.split = true
                // this.checkoutDrawer.split = this.paymentMethods[0].service
                this.checkoutDrawer.form.paymentMethod = undefined

                // let activePayment
                // if (this.paymentMethods.length) {
                //     activePayment = this.paymentMethods.find(el => el.default)
                //         || this.paymentMethods.find(el => el.digital === false)
                //         || this.paymentMethods[0]
                // }
                const split = this.paymentMethods.map(paymentMethod => {
                    return {
                        paymentMethod,
                        amount: 0,
                        placeholder: '',
                    }
                })
                this.$set(this.checkoutDrawer.form, 'split', split)
            }
        },
        updateSplitPaymentMethodAmount(i, value) {
            if (this.checkoutDrawer.form.split[i].amount !== value) {
                this.checkoutDrawer.form.split[i].amount = value

                this.checkoutDrawer.form.payed = 0
                this.checkoutDrawer.form.split.forEach(el => {
                    this.checkoutDrawer.form.payed += el.amount
                })
            }
        },
        transferSplitPaymentRemainings(i, value) {
            this.updateSplitPaymentMethodAmount(i, value)
            // this.checkoutDrawer.split = this.checkoutDrawer.form.split[i].service
            this.checkoutDrawer.split = true
        },
        async createPurchase() {
            this.checkoutDrawer.saving = true

            let payload = {
                purchase: {
                    id: this.purchaseID,
                    shop: { id: this.activeCms.shop.id },
                    purchaser: this.purchaser,
                    paymentMethod: this.checkoutDrawer.form.paymentMethod,
                    coupons: _.cloneDeep(this.coupons).filter(coupon => !coupon.disabled).map(el => {
                        return { id: el.id, code: el.code }
                    }),
                    items: _.cloneDeep(this.items).map(el => {
                        el.propertyValueOptions = el.properties.map(prop => prop.valueOption)
                        el.article = { id: el.article.id } // full article highly impacts performance
                        delete el.properties
                        return el
                    }),
                },
            }

            if (this.checkoutDrawer.split && this.checkoutDrawer.form.split.length) {
                payload.split = _.cloneDeep(this.checkoutDrawer.form.split).map(el => {
                    delete el.placeholder
                    return el
                })
            }

            // Add flag for returning remaining coupon amount as cash
            payload.returnRemainingCouponAmountAsCash = this.returnRemainingCouponAmountAsCash

            const closeDrawer = () => {
                this.checkoutDrawer.saving = false
                this.resetCheckoutDrawer()
                this.closeCheckoutDrawer()
                this.reset()
            }

            const purchase = await this.sell(payload)
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)

                    this.checkoutDrawer.saving = false

                    var serverMessage = _.get(err, 'graphQLErrors.0.message', '') || ''
                    var isTseError = serverMessage.indexOf('TSE') > -1

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: isTseError
                            ? this.$t('Purchase could not be completed because the fiscal security device (TSE) is not available. Please try again later.')
                            : this.$t('Purchase could not be completed.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: isTseError ? 15000 : 8000,
                    })
                })

            if (purchase && purchase.errors && purchase.errors.length) {
                this.checkoutDrawer.saving = false
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Purchase could not be completed.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            } else if (purchase) {
                let soldCoupons = purchase.soldCoupons;

                this.$notify.success({
                    title: this.$t('Purchase completed successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });

                try {
                    // Erst Belege drucken, dann Gutscheine
                    let showQR = true;
                    if (purchase.latestReceipt && this.checkoutDrawer.numberOfPrints > 0) {
                        showQR = false; // QR Code Dialog nicht öffnen, wenn Belege gedruckt werden
                        await this.printReceipts(purchase.latestReceipt)
                    }

                    if (soldCoupons.length > 0) {
                        await this.printCoupons(soldCoupons)
                    }

                    // Event tickets are handed over on paper too - most till buyers are guests who
                    // never gave an email address, so this print IS the delivery.
                    const eventTickets = (purchase.eventTickets || []).filter(ticket => ticket.tillRoll)
                    if (eventTickets.length > 0) {
                        await this.printCoupons(eventTickets)
                    }

                    // Print remaining amount coupon if present
                    if (purchase.remainingAmountCoupon && purchase.remainingAmountCoupon.tillRoll) {
                        await this.printCoupons([purchase.remainingAmountCoupon])
                    }

                    // Prepare cash withdrawal for remaining coupon amount if flag was set
                    // Capture payment method before closeDrawer() resets it
                    let couponWithRemaining = null;
                    let usedPaymentMethod = null;
                    if (this.returnRemainingCouponAmountAsCash && purchase.coupons) {
                        couponWithRemaining = purchase.coupons.find(c => c.remaining_amount > 0);
                        usedPaymentMethod = this.checkoutDrawer.form.paymentMethod;
                    }

                    closeDrawer()

                    // QR Code Dialog nach allem anderen öffnen
                    if (purchase.latestReceipt && showQR) {
                        await this.showQRCodeDialog(purchase.latestReceipt);
                    }

                    // Open cash book for remaining coupon amount after QR dialog closes (or immediately if no QR)
                    if (couponWithRemaining) {
                        this.$nextTick(() => {
                            this.openCashBookForRemainingAmount(couponWithRemaining, usedPaymentMethod);
                        });
                    }

                } catch (error) {
                    console.error('Printing error:', error)
                    closeDrawer()
                }

                // empty coupons after successful purchase
                this.setCoupons()

            } else if (this.checkoutDrawer.saving === true) {
                closeDrawer()
            }
        },

        printReceipts(receipt) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            return new Promise((resolve, reject) => {
                const token = AuthApi.getToken()
                const printable = `${storageRoute}/${table}/${receipt.id}/${receipt.name}?token=${token}`

                let remainingPrints = this.checkoutDrawer.numberOfPrints

                const printReceipt = () => {
                    printJS({
                        printable,
                        onLoadingEnd: () => {
                            --remainingPrints
                        },
                        onError: () => {
                            this.checkoutDrawer.saving = false
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Could not print the cash receipt!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                            reject(new Error('Receipt printing failed'))
                        },
                        onPrintDialogClose: () => {
                            if (remainingPrints > 0) {
                                printReceipt()
                            } else {
                                resolve()
                            }
                        }
                    })
                }

                printReceipt()
            })
        },

        printCoupons(soldCoupons) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            return new Promise((resolve, reject) => {
                const printCoupon = () => {
                    if (!soldCoupons.length) {
                        resolve()
                        return
                    }

                    const coupon = soldCoupons[0].tillRoll
                    const token = AuthApi.getToken()
                    const printable = `${storageRoute}/${table}/${coupon.id}/${coupon.name}?token=${token}`

                    printJS({
                        printable,
                        onLoadingEnd: () => {
                            soldCoupons.shift()
                        },
                        onError: () => {
                            soldCoupons.shift()
                            this.checkoutDrawer.saving = false
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Could not print the coupon!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                            reject(new Error('Coupon printing failed'))
                        },
                        onPrintDialogClose: () => {
                            if (soldCoupons.length > 0) {
                                printCoupon()
                            } else {
                                resolve()
                            }
                        }
                    })
                }

                printCoupon()
            })
        },

        closeCheckoutDrawer() {
            this.checkoutDrawer.visibility = false
            this.updateAutofocusSearchInput(true)
        },
        resetCheckoutDrawer() {
            this.checkoutDrawer = {
                visibility: false,
                saving: false,
                loading: false,
                split: false,
                numpad: '',
                numberOfPrints: 1,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                form: {
                    payed: 0,
                    paymentMethod: undefined
                }
            }
            this.returnRemainingCouponAmountAsCash = false
            this.updateAutofocusSearchInput(true)
        },

        openCashBookForRemainingAmount(coupon, usedPaymentMethod) {
            // Prefer cash payment method (service === 'cash'), then digital === false, then payment method used in checkout
            const cashPaymentMethod = this.paymentMethods.find(pm => pm.service === 'cash')
                || this.paymentMethods.find(pm => pm.digital === false);
            const paymentMethod = cashPaymentMethod || usedPaymentMethod;
            if (!paymentMethod) return;

            const couponName = coupon.name || `#${coupon.id}`;
            const comment = this.$t('Remaining coupon value: {name} ({code})', {
                name: couponName,
                code: coupon.code,
            });

            // Emit event to open cash book drawer with pre-filled values
            this.$emit('open-cash-book-for-remaining-amount', {
                paymentMethodId: paymentMethod.id,
                amount: coupon.remaining_amount,
                comment,
                withdrawOnly: true,
            });
        },

        getPaymentMethodIcon(paymentMethod) {
            let icon
            // switch (paymentMethod.service) {
            //     case 'cash':
            //         icon = 'fas el-icon-fa-money-bill'
            //         break;

            //     case 'card':
            //     case 'debit-card':
            //         icon = 'fas el-icon-fa-credit-card'
            //         break;

            //     case 'credit-card':
            //         icon = 'far el-icon-fa-credit-card'
            //         break;

            //     case 'split':
            //         icon = 'fas el-icon-fa-cut'
            //         break;
            // }
            if (paymentMethod.digital) {
                icon = 'far el-icon-fa-credit-card'
            } else {
                icon = 'fas el-icon-fa-money-bill'
            }
            return icon
        },

        toggleCouponSearchPopover() {
            if (this.couponSearchPopover.visibility === true) {
                this.closeCouponSearchPopover()
            } else {
                this.couponSearchPopover.visibility = true
                this.couponSearchPopover.active = true
                this.updateAutofocusSearchInput(false)
                this.$emit('blur-search')
                this.$nextTick(() => {
                    this.$refs['coupon-search-input'].focus()
                })
            }
        },
        handleCouponSearchKeyboardKeyPress(button) {
            if (button === '{enter}') this.applyCoupon()
        },
        async applyTotalDiscountCoupon(code) {
            this.couponSearchPopover.loading = true;

            const shop = this.activeCms.shop.id
            const pointOfSale = this.activePointOfSale.id
            const customer = this.purchaser.customer ? this.purchaser.customer.id : null

            let error
            const coupon = await CouponApi.apply(code, shop, pointOfSale, customer)
                .catch(err => {
                    error = err
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (coupon) {
                const previousCouponNumber = this.coupons.length
                this.addCoupon(coupon)
                // check if coupon has been added and notify
                // save cart on success
                if (this.coupons.length > previousCouponNumber) {
                    this.$notify.success({
                        title: this.$t('Coupon applied successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                    this.closeCouponSearchPopover()
                    this.save()
                } else {
                    this.$notify.warning({
                        title: this.$t('Coupon has already been applied'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            } else if (!error) {
                this.$notify.error({
                    title: this.$t('Coupon not found'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }

            this.couponSearchPopover.loading = false;

        },
        async applyCoupon() {
            this.couponSearchPopover.loading = true;

            const code = this.couponSearchPopover.form.input
            const shop = this.activeCms.shop.id
            const pointOfSale = this.activePointOfSale.id
            const customer = this.purchaser.customer ? this.purchaser.customer.id : null

            let error
            const coupon = await CouponApi.apply(code, shop, pointOfSale, customer)
                .catch(err => {
                    error = err
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (coupon) {
                const previousCouponNumber = this.coupons.length
                this.addCoupon(coupon)
                // check if coupon has been added and notify
                // save cart on success
                if (this.coupons.length > previousCouponNumber) {
                    this.$notify.success({
                        title: this.$t('Coupon applied successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                    this.closeCouponSearchPopover()
                    this.save()
                } else {
                    this.$notify.warning({
                        title: this.$t('Coupon has already been applied'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            } else if (!error) {
                this.$notify.error({
                    title: this.$t('Coupon not found'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }

            this.couponSearchPopover.loading = false;
        },
        closeCouponSearchPopover() {
            this.couponSearchPopover.visibility = false
            this.updateAutofocusSearchInput(true)
            setTimeout(() => {
                this.couponSearchPopover.active = false
                this.resetCouponSearchPopover()
            }, 400)
        },
        resetCouponSearchPopover() {
            this.couponSearchPopover = {
                visibility: false,
                saving: false,
                loading: false,
                active: false,
                form: {
                    input: '',
                },
            }
            this.updateAutofocusSearchInput(true)
        },

        toggleCustomerSearchPopover() {
            if (this.customerSearchPopover.visibility === true) {
                this.closeCustomerSearchPopover()
            } else {
                this.$set(this.customerSearchPopover, 'visibility', true)
                this.$set(this.customerSearchPopover, 'active', true)
                this.updateAutofocusSearchInput(false)
                this.$emit('blur-search')
                this.$nextTick(() => {
                    this.$refs['customer-search-input'].focus()
                })
            }
        },
        showNewMemberForm() {
            this.$set(this.customerSearchPopover.newMember, 'visibility', true)
            this.$set(this.customerSearchPopover.newMember.rules, 'email', `required|email|unique_member_email:"cms":${this.activeCms.id}`)

            if (this.activePointOfSale.assign_member_tags && this.activePointOfSale.assignableMemberTags.length) {
                const memberTags = this.activePointOfSale.assignableMemberTags
                this.$set(this.customerSearchPopover.newMember.form, 'memberTags', memberTags)
            } else {
                this.$set(this.customerSearchPopover.newMember.form, 'memberTags', [])
            }
        },
        hideNewMemberForm() {
            this.$set(this.customerSearchPopover.newMember, 'visibility', false)
        },
        createCustomer() {
            this.$refs.customerForm.validate((valid, errors) => {
                if (valid) {
                    let member = _.cloneDeep(this.customerSearchPopover.newMember.form)
                    if (!member.address.street && !member.address.zip && !member.address.city) {
                        member.address = undefined
                    } else {
                        member.address.type = 'main'
                        member.address.default_billing = true
                        member.address.default_shipping = true
                    }

                    const cms = this.activeCms;
                    member.cms = { id: cms.id };
                    member.password = uniqid()

                    let customerGroup = this.activeCms.shop.defaultCustomerGroup
                    if (this.activePointOfSale.customerGroup) customerGroup = this.activePointOfSale.customerGroup
                    member.customer = { nr: uniqid(), customerGroup }

                    this.customerSearchPopover.newMember.saving = true

                    MemberApi.create(member)
                        .then((member) => {
                            this.selectCustomer(member);
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            console.error(error)
                        })
                        .finally(() => {
                            this.customerSearchPopover.newMember.saving = false
                        })
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        handleCustomerSearchKeyboardKeyPress(button) {
            if (button === '{enter}' && !this.customerSearchPopover.newMember.visibility) {
                this.searchCustomers()
            }
        },
        searchCustomers() {
            this.customerSearchPopover.loading = true;

            // this.customerSearchPopover.loading = true;
            this.$set(this.customerSearchPopover.pagination, 'loading', true);
            this.loadCustomersIntoPopover()
        },
        async loadCustomersIntoPopover(page = 1) {
            this.$set(this.customerSearchPopover.pagination.pageInfo, 'currentPage', page)
            // if (page === 1) this.$set(this.customerSearchPopover.pagination, 'items', [])

            if (!this.customerSearchPopover.pagination.filters) {
                this.$set(this.customerSearchPopover.pagination, 'filters', {})
            }
            this.$set(this.customerSearchPopover.pagination.filters, 'cms', {
                key: 'cms',
                match: this.activeCms.id
            })
            this.$set(this.customerSearchPopover.pagination.filters, 'is_customer', {
                key: 'is_customer',
                match: true
            })
            this.$set(this.customerSearchPopover.pagination.filters, 'query', {
                key: 'query',
                like: this.customerSearchPopover.form.input
            })

            let error
            const paginatedCustomers = await MemberApi.fetchMembersPaginated(this.customerSearchPopover.pagination)
                .catch(err => {
                    error = err
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (page > 1) {
                this.customerSearchPopover.pagination.items = [...this.customerSearchPopover.pagination.items, ...paginatedCustomers.items]
            } else {
                if (this.$refs.customerSearchPopoverBody) this.$refs.customerSearchPopoverBody.scrollTop = 0
                this.customerSearchPopover.pagination = paginatedCustomers;
            }

            if (paginatedCustomers.items && paginatedCustomers.items.length) {
                this.$nextTick(() => {
                    if (this.$refs.customerSearchPopoverBody) this.loadMoreCustomersIfNeeded(this.$refs.customerSearchPopoverBody)
                })
            } else if (!error) {
                this.$notify.error({
                    title: this.$t('No customers found'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }

            this.customerSearchPopover.loading = false;
            this.$set(this.customerSearchPopover.pagination, 'loading', false);
        },
        selectCustomer(member) {
            const purchaser = {
                id: uniqid('new:'),
                name: member.name,
                customer: _.cloneDeep(member.customer)
            }
            this.setCoupons()
            this.setPurchaser(purchaser)
            this.initializeCustomerCoupons()
            // this.fetchPurchasesOnHold({
            //     customerID: member.customer.id,
            // })
            this.closeCustomerSearchPopover()
            this.save()

            // this.updateLoading(true)
            // this.load().finally(() => this.updateLoading(false))
            this.load().finally(() => this.save())
        },
        unsetCustomer() {
            this.setCoupons()
            // this.fetchPurchasesOnHold()
            this.setPurchaser()
            this.save()

            // this.updateLoading(true)
            // this.load().finally(() => this.updateLoading(false))
            this.load().finally(() => this.save())
        },
        handleCustomerSearchScroll(event) {
            const { target } = event;
            this.loadMoreCustomersIfNeeded(target)
        },
        loadMoreCustomersIfNeeded(target) {
            if (!this.customerSearchPopover.pagination) return;

            if (Array.isArray(target) && target.length === 1) target = target[0]

            const currentPage = this.customerSearchPopover.pagination.pageInfo.currentPage;
            if (target && this.customerSearchPopover.pagination.loading !== true
                && this.customerSearchPopover.pagination.pageInfo.lastPage > currentPage
            ) {
                let loadMore = false;
                // const offset = window.innerHeight * 0.8;
                const offset = window.innerHeight;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) loadMore = true;

                if (loadMore) {
                    this.$set(this.customerSearchPopover.pagination, 'loading', true);
                    this.loadCustomersIntoPopover(currentPage + 1)
                }
            }
        },
        closeCustomerSearchPopover() {
            this.$set(this.customerSearchPopover, 'visibility', false)
            this.updateAutofocusSearchInput(true)
            setTimeout(() => {
                this.$set(this.customerSearchPopover, 'active', false)
                this.resetCustomerSearchPopover()
            }, 400)
        },
        resetCustomerSearchPopover() {
            this.customerSearchPopover = {
                visibility: false,
                saving: false,
                loading: false,
                active: false,
                form: {
                    input: '',
                },
                newMember: {
                    visibility: false,
                    saving: false,
                    loading: false,
                    focusedField: undefined,
                    form: {
                        gender: undefined,
                        first_name: '',
                        last_name: '',
                        mobile: '',
                        phone: '',
                        email: '',
                        // password: '',
                        address: {
                            street: '',
                            zipcode: '',
                            city: '',
                            country: '',
                        },
                        memberTags: [],
                    },
                    rules: {
                        gender: 'required',
                        first_name: 'required',
                        last_name: 'required',
                        email: `required|email|unique_member_email:"cms":${this.activeCms.id}`,
                        // address: {
                        //     street: 'required',
                        //     zipcode: 'required',
                        //     city: 'required',
                        //     country: 'required',
                        // },
                    }
                },
                pagination: {
                    filters: {},
                    pageInfo: {
                        total: 0,
                        perPage: 12,
                        currentPage: 1,
                        lastPage: 0,
                    },
                    items: []
                }
            }
            this.updateAutofocusSearchInput(true)
        },
        showQRCodeDialog(latestReceipt) {
            return new Promise((resolve) => {
                this.qrCodeModal.visibility = true
                this.qrCodeModal.loading = true
                this.qrCodeModal.resolve = resolve
                const input = { 'visibility': 'public', 'ids': [parseInt(latestReceipt.id)] }
                FileApi.changeFileVisibility(input).then(() => {
                    this.qrCodeModal.loading = false
                    this.qrCodeModal.latestReceipt = latestReceipt
                    this.drawQrCode(latestReceipt)
                })
            })
        },
        resetQrCodeModal() {
            // Ensure visibility is false
            this.qrCodeModal.visibility = false
            if (this.qrCodeModal.latestReceipt != null) {
                const input = { 'visibility': 'private', 'ids': [parseInt(this.qrCodeModal.latestReceipt.id)] }
                FileApi.changeFileVisibility(input).then(() => {
                    this.qrCodeModal.latestReceipt = null
                })
            }
            // Resolve the promise to signal dialog is closed
            if (this.qrCodeModal.resolve) {
                this.qrCodeModal.resolve()
                this.qrCodeModal.resolve = null
            }
        },
        drawQrCode(latestReceipt) {
            const storageRoute = _.trim(
                `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );
            const table = 'files';
            const link = `${storageRoute}/${table}/${latestReceipt.id}/${encodeURIComponent(latestReceipt.name)}?download`;
            // QRCode.toCanvas(document.getElementById('qrcanvas'), link, function (error) {
            QRCode.toCanvas(this.$refs.qrcanvas, link, function (error) {
                if (error) console.error(error)
            })
        },
        updateAutofocusSearchInput(value) {
            return this.posSetupStore.updateAutofocusSearchInput(value);
        },
        updateLoading(value) {
            return this.posSetupStore.updateLoading(value);
        },
        updateItemQtyMutation(payload) {
            return this.posCartStore.updateItemQty(payload);
        },
        updateItemQuantities(payload) {
            return this.posCartStore.updateItemQuantities(payload);
        },
        updateArticleStocks(article) {
            return this.posCartStore.updateArticleStocks(article);
        },
        deleteItemMutation(item) {
            return this.posCartStore.deleteItem(item);
        },
        updateItem(item) {
            return this.posCartStore.updateItem(item);
        },
        setPurchaser(purchaser) {
            return this.posCartStore.setPurchaser(purchaser);
        },
        setCoupons(coupons) {
            return this.posCartStore.setCoupons(coupons);
        },
        addCoupon(coupon) {
            return this.posCartStore.addCoupon(coupon);
        },
        load() {
            return this.posCartStore.load();
        },
        save() {
            return this.posCartStore.save();
        },
        sell(payload) {
            return this.posCartStore.sell(payload);
        },
        sellLater(payload) {
            return this.posCartStore.sellLater(payload);
        },
        requestArticles(payload) {
            return this.posCartStore.requestArticles(payload);
        },
        initializeCustomerCoupons() {
            return this.posCartStore.initializeCustomerCoupons();
        },
        fetchPurchasesOnHold(payload) {
            return this.posSetupStore.fetchPurchasesOnHold(payload);
        },
        reset() {
            return this.posCartStore.clear();
        }
    }
}
</script>

<style lang="sass" scoped>
.shopping-cart
    display: contents
    & > .body
        display: flex
        flex-direction: column
        // background: rgba(0,0,0,0.1)
        position: relative
        flex-grow: 1
        /* overflow-x: hidden */
        overflow-y: auto
        /* max-height: 100% */
        /* max-height: calc(100vh - 140px) */
        max-height: calc(100vh - 140px - 80px)
        .scroll-box
            padding: 1rem
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            overflow-x: hidden
            overflow-y: auto
    &.empty-list > .body
        max-height: none
    .foot
        padding: 1rem
        display: grid
        gap: 0.5rem
        grid-template-rows: repeat(2, 50px)
        grid-template-columns: repeat(12, minmax(0, 1fr))
        button.is-loading
            display: flex
            align-items: center
            justify-content: center
        button.gray-box
            position: relative
            text-align: left
            outline: none
            border: none
            font-size: inherit
            cursor: pointer
            align-items: flex-start
            flex-direction: column
            &:hover, &:focus
                // outline: 1px solid $--shop-color-primary
                box-shadow: inset 0 0 0px 0.125rem rgba($--shop-color-primary, 0.9)
                .value
                    color: $--shop-color-primary
            label
                pointer-events: none
            button.unset-customer
                position: absolute
                right: 0
                top: 0
                height: 100%
                width: 40px
                background: none
                border: none
                color: darken($color-skeleton, 60%)
                cursor: pointer
                &:hover, &:focus
                    color: $--color-danger
        .el-button + .el-button
            margin-left: 0
        .coupons
            grid-column: 1 / 5
            grid-row: 1 / 3
            position: relative
            .flex-row
                display: flex
                justify-content: space-between
                align-items: flex-end
                position: absolute
                bottom: 6px
                left: 16px
                width: calc(100% - 16px - 16px)
        .customer
            flex-grow: 1
        .grand-total
            flex-grow: 1
            // label,
            .value
                text-align: right
        .session,
        .summary
            grid-column: 5 / 13
            background: none
            display: flex
            gap: 0.5rem
            padding: 0
            .action
                width: auto
                min-width: 4rem
                font-size: 1.4rem
        &.has-coupons
            .coupons
                grid-column: 1 / 6
            .session,
            .summary
                grid-column: 6 / 13

.nothing-scanned
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: darken($color-skeleton, 20%)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: darken($color-skeleton, 30%)
    p
        color: darken($color-skeleton, 30%)

.customize-price
    padding-top: 3px
    padding-bottom: 3px
    height: 36px
    .red,
    .main-price s,
    .sale-price s
        transition: color 0.15s
    .main-price s:before,
    .sale-price s:before
        transition: border-color 0.15s
    &:hover
        .red
            color: #fff
        .main-price s,
        .sale-price s
            color: rgba(255,255,255,0.6)
        .main-price s:before,
        .sale-price s:before
            border-color: rgba(255,255,255,0.6)

.inactive-tag
    flex-shrink: 0

.items
    padding: 1rem
    width: 100%
    table
        width: 100%
        border-spacing: unset
        .dimmed
            color: $color-grey-text
        .divider hr
            opacity: 0.5

        // .name
            display: flex
            max-width: 100%
            .trim-wrap
                flex: 1 1 100%
                min-width: 0
                .trim
                    max-width: 100%
                    overflow: hidden
                    text-overflow: ellipsis
                    white-space: nowrap

        .properties
            display: flex
            gap: 4px
            ::v-deep .property-value
                padding: 4px 6px
                background: darken($color-skeleton, 10%)
                border-radius: 4px
                font-size: 0.85em
                label
                    font-size: 0.8em
                    display: block
                    &:after
                        content: ''
        .actions
            .delete-item
                margin-left: 1rem
            &.flex-row
                align-items: center
            .unsavable
                color: $--color-danger
                svg
                    position: relative
                    width: 1.5rem
                    height: 1.5rem
                    cursor: pointer
                    bottom: -2px
                    fill: currentColor
        th
            font-size: 0.8rem
            position: sticky
            top: 0
            background: rgba(242,244,248, 0.9)
            background: linear-gradient(0deg, rgba(242,244,248,0.6) 0%, rgba(242,244,248,1) 95%, rgba(242,244,248,1) 100%)
            backdrop-filter: blur(10px)
            padding: 0.4rem
            padding-top: 0
            z-index: 5

        td
            // vertical-align: top
            padding: 2px 0.4rem
            &.min
                width: 1px
            &.info
                padding-left: 0
            .bottom-row
                display: flex
                justify-content: space-between
                align-items: flex-end
        tr
            td, th
                &:first-child
                    padding-left: 0
                &:last-child
                    padding-right: 0
        .el-input-number.qty
            // width: 100px
            width: 120px

.modal-footer
    display: flex
    justify-content: space-between
    .left
        display: flex
        align-items: center

.stocks-modal,
.discount-modal
    .info
        flex-grow: 1
        min-width: 0
        padding: 6px 0
        .row
            display: flex
            gap: 0.5rem
            & + .row
                margin-top: 0.25rem
        .name
            flex-grow: 1
            min-width: 0
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
        .sku
            flex-grow: 1
        ::v-deep label
            font-weight: bold
        label + span.value:before
            content: ' '
        label
            font-style: italic
            &.small
                font-size: 0.8em
    .main-price,
    .sale-price
        margin-top: 1rem
        & > .el-form-item
            width: 100%
        .gray-box
            margin-bottom: 10px
            input.v-money
                padding-top: 6px
    .percentages
        // min-width: 40%
        min-width: 160px
        margin-left: 2rem
        margin-top: 24px
        margin-bottom: 23px
        display: flex
        flex-direction: column
        justify-content: space-between
        button
            margin: 0
            &::v-deep span
                pointer-events: none
    .roundings,
    .total-percentages
        min-width: 110px
        margin-left: 2rem
        margin-bottom: 23px
        display: flex
        gap: 4px
        flex-direction: column
        justify-content: flex-start
        button
            margin: 0
            &::v-deep span
                pointer-events: none
.main-price,
.sale-price
    s
        display: inline-block
        font-size: 0.8em
        // font-weight: bold
        text-decoration: none
        color: rgba(0,0,0,0.6)
    .red
        color: $--color-danger
        &.dimmed
            color: lighten($--color-danger, 10%)
    .strike-through
        position: relative
        &:before
            position: absolute
            content: ""
            left: -3px
            top: 50%
            right: -3px
            border-top: 1px solid rgba(0,0,0,0.6)
            // border-color: $--color-info
            transform: rotate(-5deg)
        &.dimmed:before
            border-color: rgba(0,0,0,0.25)
    .v-money.value
        &:focus-visible
            outline: none
            // color: $--shop-color-primary
            border-bottom: 2px solid $--shop-color-primary


// .price-type-buttons
//     position: relative
//     bottom: calc(-1rem - 4px)
//     width: 100%
//     display: flex
//     justify-content: space-between
//     button
//         padding: 6px 12px
//         padding-bottom: 8px
//         border-radius: 4px
//         border-bottom-left-radius: 0
//         border-bottom-right-radius: 0
//         border: none
//         // margin-right: 4px
//         // background: #fafeff
//         background: none
//         color: darken($color-skeleton, 30%)
//         &.active
//             background: #f5f7fa
//             color: $--shop-color-primary

.discount-modal .prices .percentages
    margin-left: 1rem
    margin-top: 41px
    margin-bottom: 0

.discount-modal .flex-row .left::v-deep .numpad-grid
    grid-template-rows: repeat(5, 56px)

.main-price .no-margin .gray-box,
.sale-price .no-margin .gray-box
    margin-bottom: 0
    & + .numpad
        margin-top: 10px

.stocks-modal table
    .min.icon
        padding-left: 8px
        padding-right: 0
    .name
        padding-left: 8px

    .icon
        i
            font-size: 1.2rem
        &.sold-out
            color: $--color-warning
        &.enabled
            color: $--color-success
        &.disabled
            color: $--color-danger
    .actions::v-deep
        .el-loading-mask
            background: rgba(250, 250, 250, 0.8)
            pointer-events: none
            svg
                width: 24px
                circle
                    stroke-width: 4px

.nobr
    white-space: nowrap

.from, .to
    display: inline-block
.from + .to
    margin-left: 1rem

.danger
    color: $--color-danger

body.point-of-sale.show-navigation
    .shopping-cart > .body
        max-height: calc(100vh - 140px - 142px)

.checkout-drawer
    .drawer-body
        height: calc(100vh - 66px - 72px)
        overflow: auto
        padding: 0 20px
    .buttons
        display: flex
        flex-wrap: wrap
        gap: 4px
        // align-items: center
        // justify-content: center
        margin: 2rem 0
        button
            margin: 0
    .gray-box
        background: darken($color-skeleton, 5%)
        padding: 6px 20px
        label
            color: darken($color-skeleton, 50%)
        .value
            font-size: 1.2rem
            // font-weight: 300
            // margin-top: 4px
    .summary
        margin: 0.5rem 0
        display: flex
        gap: 0.5rem
        .grand-total
            flex-grow: 1
            // text-align: right
    .split
        display: flex
        // flex-direction: column
        // flex-wrap: wrap
        flex-direction: column
        gap: 0.5rem
        .payment
            .money
                flex-direction: column
                gap: 2px
                &.inactive
                    .value.input
                        display: none
                    input.v-money.value
                        color: initial
                    .remainings, .change
                        display: none
                .remainings, .change
                    display: flex
                    .gray-box
                        background: none
                .remainings
                    align-items: center

    .cash
        margin-top: 0.5rem
    .v-money.value.invalid:not(:focus)
        box-shadow: inset 0 0 0px 0.125rem rgba($--color-danger, 0.9)
        border-radius: 4px
        + .value
            color: $--color-danger

.previously-purchased-items-drawer
    .drawer-body::v-deep
        display: flex
        flex-direction: column
        padding: 20px
        padding-top: 0
        height: calc(100vh - 66px)
        .el-loading-mask
            position: absolute
            inset: 0

.contains-numpad
    display: flex
    gap: 0.5rem
    input
        background: none
        // letter-spacing: 0.4px
        border: none
        position: absolute
        color: inherit
        left: 0
        top: 0
        width: 100%
        padding: 6px 20px
        padding-top: 23px
        margin: 0
        color: rgba(0,0,0,.2)
        &:focus
            color: inherit
            z-index: 2
            & + .value.input
                display: none
    .input-payed-amount
        .gray-box
            margin-bottom: 0.5rem
        input
            text-align: right
    .money
        display: flex
        gap: 0.5rem
        flex-grow: 1
        .exact-amount-payed
            margin-top: 0.6rem
    .payed
        min-width: 188px
        // min-width: 148px
    .v-money.value
        font-family: inherit
    .value.input
        position: absolute
        line-height: 1
        bottom: 10px
        left: 20px
        background: $--background-color-base
        z-index: 1
    .change
        flex-grow: 1
    .gray-box
        position: relative
        // min-height: 52px
        & > div
            line-height: 27px
    .numpad
        // min-width: 152px
        // margin-top: 0.5rem
        // margin-bottom: 15px
        ::v-deep button
            font-size: 1.2rem
    .invisible
        opacity: 0
        &.value
            padding-right: 10px

.customer-search-popover,
.coupon-search-popover
    display: flex
    flex-direction: column
    position: absolute
    left: 1rem
    right: 1rem
    // top: 1rem
    bottom: 140px
    max-height: calc(100vh - 156px)
    z-index: 10
    &.gray-box
        padding-top: 1rem
        padding-bottom: 1rem
    &:after
        content: ''
        position: absolute
        bottom: -0.55rem
        left: calc(50% - 0.6rem)
        border-style: solid
        border-width: 0.6rem 0.6rem 0
        border-color: darken($color-skeleton, 10%) transparent
        display: block
        width: 0
    .list
        flex-grow: 1
        overflow-y: auto
        margin-bottom: 1rem
        &.is-empty
            margin-bottom: 0
            .popover-spinner-container
                margin-bottom: 1rem
    .input
        position: relative
        .spinner
            position: absolute
            right: 10px
            top: 8px
            width: 20px
            height: 20px
            z-index: 1
    .bottom-row,
    .search-input
        margin-bottom: 0.5rem

    .popover-spinner-container
        width: 100%
        /* padding: 1rem */
        /* padding-top: 0 */
        display: flex
        justify-content: center
        align-items: center

    ul.customers + .popover-spinner-container
        margin-top: 1rem

    li.customer
        display: flex
        gap: 1rem
        justify-content: space-between
        & + li.customer
            margin-top: 0.5rem
            padding-top: 0.5rem
            border-top: 1px solid rgba(0,0,0, 0.1)
        .row
            display: flex
            gap: 0.5rem
            .grow
                flex-grow: 1
        .name
            font-weight: bold
        .infos
            flex-grow: 1
            justify-content: center
        .email, .phone
            white-space: nowrap

.customer-search-popover
    &:after
        left: calc(100% / 12 * 4 + 1.6rem)
    &.has-coupons:after
        left: calc(100% / 12 * 6 + 1.6rem)
    .form
        overflow-y: auto
        overflow-x: hidden

.coupon-search-popover
    &:after
        content: ''
        position: absolute
        bottom: -0.55rem
        left: 1.6rem

.gray-box
    background: darken($color-skeleton, 10%)
    padding: 4px 1rem
    padding-bottom: 6px
    border-radius: 4px
    // height: 50px
    display: flex
    flex-direction: column
    &.input
        background: $--background-color-base
    &.active
        z-index: 10
    label
        color: darken($color-skeleton, 60%)
        font-style: italic
        display: block
        font-size: 0.8em
    .value
        margin-top: 2px
        display: block
        font-size: 1.2rem
        &.gray
            color: darken($color-skeleton, 30%)
            i
                color: inherit
        &.grow
            width: 100%
            flex-grow: 1
            justify-content: center
            align-items: center
            display: flex
        svg.icon
            width: 40px

.backdrop
    position: fixed
    // background: rgba($--background-color-base, 60%)
    background: rgba(0, 0, 0, 0.5)
    width: 100%
    height: 100%
    top: 0
    left: 0
    z-index: 5
    /* backdrop-filter: blur(5px) */
    backdrop-filter: grayscale

th.spinner-container
    padding: 0
    padding-left: 8px
    vertical-align: middle
    .spinner
        width: 18px
        height: 18px

.add-customer
    height: 36px

.el-input::v-deep
    .el-input__prefix
        display: flex
        justify-content: center
        align-items: center
        width: 24px

.el-select.is-small
    max-width: 140px

.el-button--text
    padding: 0

.el-input-number.qty
    width: 120px

.el-input.qty
    width: 120px
    ::v-deep input
        padding-left: 30px
        text-align: center
.flex
    display: flex

.pencil
    // background: #E0E0E0
    // border: 1px solid gray

.justify-end
    justify-content: end


.el-dialog__wrapper.qrcode-modal
    &::v-deep .el-dialog__body
        display: flex
        flex-direction: column
        align-items: center
        button
            margin-top: 20px

.el-button.flex
    display: flex
    align-items: center

.line-through
    text-decoration: line-through

.red
    margin-left: 12px
    color: red

h3
    font-weight: 300

.hide-label:deep(label)
    display: none !important
</style>
